import { range } from "./arrays";
const YearsSince1980 = new Date().getUTCFullYear() - 1980;
export const VehicleYears = range(YearsSince1980, 1981).reverse();
export const VehicleYearsStrings = VehicleYears.map(year => year.toString());
export const States = [{
  abbreviation: "AL",
  name: "Alabama"
}, {
  abbreviation: "AK",
  name: "Alaska"
}, {
  abbreviation: "AZ",
  name: "Arizona"
}, {
  abbreviation: "AR",
  name: "Arkansas"
}, {
  abbreviation: "CA",
  name: "California"
}, {
  abbreviation: "CO",
  name: "Colorado"
}, {
  abbreviation: "CT",
  name: "Connecticut"
}, {
  abbreviation: "DE",
  name: "Delaware"
}, {
  abbreviation: "DC",
  name: "District of Columbia"
}, {
  abbreviation: "FL",
  name: "Florida"
}, {
  abbreviation: "GA",
  name: "Georgia"
}, {
  abbreviation: "HI",
  name: "Hawaii"
}, {
  abbreviation: "ID",
  name: "Idaho"
}, {
  abbreviation: "IL",
  name: "Illinois"
}, {
  abbreviation: "IN",
  name: "Indiana"
}, {
  abbreviation: "IA",
  name: "Iowa"
}, {
  abbreviation: "KS",
  name: "Kansas"
}, {
  abbreviation: "KY",
  name: "Kentucky"
}, {
  abbreviation: "LA",
  name: "Louisiana"
}, {
  abbreviation: "ME",
  name: "Maine"
}, {
  abbreviation: "MD",
  name: "Maryland"
}, {
  abbreviation: "MA",
  name: "Massachusetts"
}, {
  abbreviation: "MI",
  name: "Michigan"
}, {
  abbreviation: "MN",
  name: "Minnesota"
}, {
  abbreviation: "MS",
  name: "Mississippi"
}, {
  abbreviation: "MO",
  name: "Missouri"
}, {
  abbreviation: "MT",
  name: "Montana"
}, {
  abbreviation: "NE",
  name: "Nebraska"
}, {
  abbreviation: "NV",
  name: "Nevada"
}, {
  abbreviation: "NH",
  name: "New Hampshire"
}, {
  abbreviation: "NJ",
  name: "New Jersey"
}, {
  abbreviation: "NM",
  name: "New Mexico"
}, {
  abbreviation: "NY",
  name: "New York"
}, {
  abbreviation: "NC",
  name: "North Carolina"
}, {
  abbreviation: "ND",
  name: "North Dakota"
}, {
  abbreviation: "OH",
  name: "Ohio"
}, {
  abbreviation: "OK",
  name: "Oklahoma"
}, {
  abbreviation: "OR",
  name: "Oregon"
}, {
  abbreviation: "PA",
  name: "Pennsylvania"
}, {
  abbreviation: "RI",
  name: "Rhode Island"
}, {
  abbreviation: "SC",
  name: "South Carolina"
}, {
  abbreviation: "SD",
  name: "South Dakota"
}, {
  abbreviation: "TN",
  name: "Tennessee"
}, {
  abbreviation: "TX",
  name: "Texas"
}, {
  abbreviation: "UT",
  name: "Utah"
}, {
  abbreviation: "VT",
  name: "Vermont"
}, {
  abbreviation: "VA",
  name: "Virginia"
}, {
  abbreviation: "WA",
  name: "Washington"
}, {
  abbreviation: "WV",
  name: "West Virginia"
}, {
  abbreviation: "WI",
  name: "Wisconsin"
}, {
  abbreviation: "WY",
  name: "Wyoming"
}, {
  abbreviation: "BC",
  name: "British Columbia"
}, {
  abbreviation: "AB",
  name: "Alberta"
}, {
  abbreviation: "SK",
  name: "Saskatchewan"
}, {
  abbreviation: "MB",
  name: "Manitoba"
}, {
  abbreviation: "ON",
  name: "Ontario"
}, {
  abbreviation: "QC",
  name: "Quebec"
}, {
  abbreviation: "NL",
  name: "Newfoundland"
}, {
  abbreviation: "NB",
  name: "New Brunswick"
}, {
  abbreviation: "NS",
  name: "Nova Scotia"
}, {
  abbreviation: "PE",
  name: "Prince Edward Is."
}, {
  abbreviation: "YT",
  name: "Yukon"
}, {
  abbreviation: "NT",
  name: "NW Territories"
}, {
  abbreviation: "NU",
  name: "Nunavut"
}, {
  abbreviation: "MX",
  name: "Mexico"
}];
export const Provinces = [{
  abbreviation: "AB",
  name: "Alberta"
}, {
  abbreviation: "BC",
  name: "British Columbia"
}, {
  abbreviation: "MB",
  name: "Manitoba"
}, {
  abbreviation: "NB",
  name: "New Brunswick"
}, {
  abbreviation: "NL",
  name: "Newfoundland and Labrador"
}, {
  abbreviation: "NS",
  name: "Nova Scotia"
}, {
  abbreviation: "NT",
  name: "Northwest Territories"
}, {
  abbreviation: "NU",
  name: "Nunavut"
}, {
  abbreviation: "ON",
  name: "Ontario"
}, {
  abbreviation: "PE",
  name: "Prince Edward Island"
}, {
  abbreviation: "QC",
  name: "Quebec"
}, {
  abbreviation: "SK",
  name: "Saskatchewan"
}, {
  abbreviation: "YT",
  name: "Yukon"
}];
export const TimeZones = ["America/Anchorage", "America/Chicago", "America/Denver", "America/Los_Angeles", "America/New_York", "America/Phoenix"];
export const VehicleColors = [{
  hex: "#000000",
  name: "BLACK"
}, {
  hex: "#178cc4",
  name: "BLUE"
}, {
  hex: "#614126",
  name: "BROWN"
}, {
  hex: "#64a855",
  name: "GREEN"
}, {
  hex: "#6f6f6f",
  name: "GRAY"
}, {
  hex: "#FFFFFF",
  name: "WHITE"
}, {
  hex: "#d4af37",
  name: "GOLD"
}, {
  hex: "#dedcd6",
  name: "SILVER"
}, {
  hex: "#e12b08",
  name: "RED"
}, {
  hex: "#ffd700",
  name: "YELLOW"
}];
export const VehicleMakes = [{
  nhtsaId: 475,
  makeId: "ACURA",
  name: "Acura",
  models: [{
    nhtsaId: "1867",
    name: "ZDX"
  }, {
    nhtsaId: "1871",
    name: "RDX"
  }, {
    nhtsaId: "1872",
    name: "RL"
  }, {
    nhtsaId: "1873",
    name: "TL"
  }, {
    nhtsaId: "1874",
    name: "TSX"
  }, {
    nhtsaId: "2147",
    name: "MDX"
  }, {
    nhtsaId: "2149",
    name: "RLX"
  }, {
    nhtsaId: "2150",
    name: "ILX"
  }, {
    nhtsaId: "3183",
    name: "RSX"
  }, {
    nhtsaId: "5063",
    name: "Integra"
  }, {
    nhtsaId: "5145",
    name: "CL"
  }, {
    nhtsaId: "5168",
    name: "NSX"
  }, {
    nhtsaId: "5339",
    name: "Legend"
  }, {
    nhtsaId: "5354",
    name: "TLX"
  }, {
    nhtsaId: "6004",
    name: "SLX"
  }, {
    nhtsaId: "11495",
    name: "Vigor"
  }]
}, {
  nhtsaId: 493,
  makeId: "ALFA",
  name: "Alfa Romeo",
  models: [{
    nhtsaId: "2035",
    name: "4C"
  }, {
    nhtsaId: "2344",
    name: "8C Competizione Spider"
  }, {
    nhtsaId: "9953",
    name: "164"
  }, {
    nhtsaId: "10326",
    name: "Giulia (952)"
  }, {
    nhtsaId: "14326",
    name: "Spider "
  }, {
    nhtsaId: "14328",
    name: "Milano"
  }, {
    nhtsaId: "14330",
    name: "GTV6"
  }]
}, {
  nhtsaId: 1124,
  makeId: "AMC",
  name: "American Motors Corporation",
  models: [{
    nhtsaId: "17403",
    name: "Eagle"
  }, {
    nhtsaId: "17404",
    name: "Eagle 30"
  }, {
    nhtsaId: "17406",
    name: "Concord"
  }, {
    nhtsaId: "17407",
    name: "Spirit"
  }]
}, {
  nhtsaId: 951,
  makeId: "AMGEN",
  name: "Hummer ",
  models: [{
    nhtsaId: "4598",
    name: "H2"
  }, {
    nhtsaId: "4599",
    name: "H3"
  }, {
    nhtsaId: "14474",
    name: "H1"
  }, {
    nhtsaId: "25774",
    name: "H3T"
  }]
}, {
  nhtsaId: 440,
  makeId: "ASTON",
  name: "Aston Martin",
  models: [{
    nhtsaId: "1684",
    name: "V8 Vantage"
  }, {
    nhtsaId: "1686",
    name: "DBS"
  }, {
    nhtsaId: "1687",
    name: "DB9"
  }, {
    nhtsaId: "1688",
    name: "Rapide"
  }, {
    nhtsaId: "1695",
    name: "V12 Vantage"
  }, {
    nhtsaId: "1697",
    name: "Virage"
  }, {
    nhtsaId: "1701",
    name: "Vanquish"
  }, {
    nhtsaId: "13751",
    name: "DB11"
  }, {
    nhtsaId: "14157",
    name: "Lagonda"
  }, {
    nhtsaId: "14162",
    name: "Vantiage"
  }, {
    nhtsaId: "14164",
    name: "V8"
  }, {
    nhtsaId: "19609",
    name: "Vanquish S"
  }, {
    nhtsaId: "19610",
    name: "Vanquish Zagato"
  }]
}, {
  nhtsaId: 582,
  makeId: "AUDI",
  name: "Audi",
  models: [{
    nhtsaId: "3145",
    name: "TT"
  }, {
    nhtsaId: "3146",
    name: "A4"
  }, {
    nhtsaId: "3147",
    name: "S4"
  }, {
    nhtsaId: "3148",
    name: "A6"
  }, {
    nhtsaId: "3149",
    name: "RS6"
  }, {
    nhtsaId: "3150",
    name: "allroad"
  }, {
    nhtsaId: "3151",
    name: "A8"
  }, {
    nhtsaId: "3675",
    name: "RS4"
  }, {
    nhtsaId: "3676",
    name: "A3"
  }, {
    nhtsaId: "3677",
    name: "S6"
  }, {
    nhtsaId: "3678",
    name: "S8"
  }, {
    nhtsaId: "3679",
    name: "Q7"
  }, {
    nhtsaId: "3787",
    name: "A5"
  }, {
    nhtsaId: "3788",
    name: "S5"
  }, {
    nhtsaId: "3789",
    name: "R8"
  }, {
    nhtsaId: "3861",
    name: "TTS"
  }, {
    nhtsaId: "3862",
    name: "Q5"
  }, {
    nhtsaId: "4014",
    name: "RS5"
  }, {
    nhtsaId: "4015",
    name: "A7"
  }, {
    nhtsaId: "4016",
    name: "TT RS"
  }, {
    nhtsaId: "4051",
    name: "Q3"
  }, {
    nhtsaId: "4052",
    name: "SQ5"
  }, {
    nhtsaId: "8056",
    name: "90"
  }, {
    nhtsaId: "8057",
    name: "100"
  }, {
    nhtsaId: "8058",
    name: "V8"
  }, {
    nhtsaId: "8059",
    name: "Cabriolet"
  }, {
    nhtsaId: "8173",
    name: "S3"
  }, {
    nhtsaId: "8258",
    name: "S7"
  }, {
    nhtsaId: "8685",
    name: "RS7"
  }, {
    nhtsaId: "13759",
    name: "A4 allroad"
  }, {
    nhtsaId: "13785",
    name: "A3 Sportback e-tron"
  }, {
    nhtsaId: "14336",
    name: "5000"
  }, {
    nhtsaId: "14337",
    name: "4000"
  }, {
    nhtsaId: "14342",
    name: "80"
  }, {
    nhtsaId: "14343",
    name: "200"
  }, {
    nhtsaId: "14348",
    name: "Coupe"
  }, {
    nhtsaId: "16783",
    name: "RS3"
  }, {
    nhtsaId: "25317",
    name: "Q8"
  }]
}, {
  nhtsaId: 583,
  makeId: "BENTL",
  name: "Bentley",
  models: [{
    nhtsaId: "9787",
    name: "Continental"
  }, {
    nhtsaId: "9788",
    name: "Brooklands"
  }, {
    nhtsaId: "9789",
    name: "Azure"
  }, {
    nhtsaId: "9791",
    name: "Turbo"
  }, {
    nhtsaId: "9822",
    name: "Mulsanne"
  }, {
    nhtsaId: "9823",
    name: "Flying Spur"
  }, {
    nhtsaId: "9824",
    name: "Eight"
  }, {
    nhtsaId: "9829",
    name: "Arnage"
  }, {
    nhtsaId: "13081",
    name: "ARMOURED ARNAGE"
  }, {
    nhtsaId: "13192",
    name: "Roll Royce Silver Seraph"
  }, {
    nhtsaId: "13193",
    name: "Rolls-Royce Park Ward"
  }, {
    nhtsaId: "14006",
    name: "Bentayga"
  }]
}, {
  nhtsaId: 452,
  makeId: "BMW",
  name: "BMW",
  models: [{
    nhtsaId: "1707",
    name: "128i"
  }, {
    nhtsaId: "1708",
    name: "135i"
  }, {
    nhtsaId: "1709",
    name: "328i"
  }, {
    nhtsaId: "1710",
    name: "M3"
  }, {
    nhtsaId: "1711",
    name: "335i"
  }, {
    nhtsaId: "1712",
    name: "335is"
  }, {
    nhtsaId: "1713",
    name: "335d"
  }, {
    nhtsaId: "1714",
    name: "X6"
  }, {
    nhtsaId: "1715",
    name: "528i"
  }, {
    nhtsaId: "1716",
    name: "535i"
  }, {
    nhtsaId: "1717",
    name: "X5"
  }, {
    nhtsaId: "1718",
    name: "550i"
  }, {
    nhtsaId: "1719",
    name: "X3"
  }, {
    nhtsaId: "1720",
    name: "740i"
  }, {
    nhtsaId: "1721",
    name: "740Li"
  }, {
    nhtsaId: "1722",
    name: "750i"
  }, {
    nhtsaId: "1723",
    name: "750Li"
  }, {
    nhtsaId: "1724",
    name: "760Li"
  }, {
    nhtsaId: "1725",
    name: "Z4"
  }, {
    nhtsaId: "1727",
    name: "750xi"
  }, {
    nhtsaId: "1728",
    name: "750Lxi"
  }, {
    nhtsaId: "1729",
    name: "M6"
  }, {
    nhtsaId: "1730",
    name: "528xi"
  }, {
    nhtsaId: "1731",
    name: "640i"
  }, {
    nhtsaId: "1732",
    name: "650i"
  }, {
    nhtsaId: "1733",
    name: "650xi"
  }, {
    nhtsaId: "1970",
    name: "1M"
  }, {
    nhtsaId: "1971",
    name: "Active E"
  }, {
    nhtsaId: "2024",
    name: "M5"
  }, {
    nhtsaId: "2170",
    name: "228i"
  }, {
    nhtsaId: "2171",
    name: "M235i"
  }, {
    nhtsaId: "2172",
    name: "320i"
  }, {
    nhtsaId: "2173",
    name: "328d"
  }, {
    nhtsaId: "2178",
    name: "i3"
  }, {
    nhtsaId: "2179",
    name: "i8"
  }, {
    nhtsaId: "2219",
    name: "ActiveHybrid 3"
  }, {
    nhtsaId: "2220",
    name: "428i"
  }, {
    nhtsaId: "2230",
    name: "435i"
  }, {
    nhtsaId: "2231",
    name: "535d"
  }, {
    nhtsaId: "2240",
    name: "ActiveHybrid 5"
  }, {
    nhtsaId: "2300",
    name: "X1"
  }, {
    nhtsaId: "2376",
    name: "535xi"
  }, {
    nhtsaId: "2377",
    name: "328xi"
  }, {
    nhtsaId: "2378",
    name: "335xi"
  }, {
    nhtsaId: "2584",
    name: "525i"
  }, {
    nhtsaId: "2585",
    name: "530i"
  }, {
    nhtsaId: "2586",
    name: "530xi"
  }, {
    nhtsaId: "2587",
    name: "525xi"
  }, {
    nhtsaId: "2759",
    name: "325Cic"
  }, {
    nhtsaId: "2760",
    name: "330Cic"
  }, {
    nhtsaId: "2761",
    name: "M3Cic"
  }, {
    nhtsaId: "2762",
    name: "325Ci"
  }, {
    nhtsaId: "2763",
    name: "330Ci"
  }, {
    nhtsaId: "2764",
    name: "325i"
  }, {
    nhtsaId: "2765",
    name: "325xi"
  }, {
    nhtsaId: "2766",
    name: "325xiT"
  }, {
    nhtsaId: "2767",
    name: "530xiT"
  }, {
    nhtsaId: "2777",
    name: "330i"
  }, {
    nhtsaId: "2778",
    name: "330xi"
  }, {
    nhtsaId: "2804",
    name: "760i"
  }, {
    nhtsaId: "3050",
    name: "325iT"
  }, {
    nhtsaId: "3051",
    name: "545i"
  }, {
    nhtsaId: "3052",
    name: "645Ci"
  }, {
    nhtsaId: "3053",
    name: "645Cic"
  }, {
    nhtsaId: "3054",
    name: "745i"
  }, {
    nhtsaId: "3055",
    name: "745Li"
  }, {
    nhtsaId: "5178",
    name: "318i"
  }, {
    nhtsaId: "5185",
    name: "318iS"
  }, {
    nhtsaId: "5186",
    name: "318iC"
  }, {
    nhtsaId: "5187",
    name: "325iS"
  }, {
    nhtsaId: "5190",
    name: "325iC"
  }, {
    nhtsaId: "5193",
    name: "525iT"
  }, {
    nhtsaId: "5194",
    name: "530iT"
  }, {
    nhtsaId: "5195",
    name: "540i"
  }, {
    nhtsaId: "5198",
    name: "840Ci"
  }, {
    nhtsaId: "5199",
    name: "850Ci"
  }, {
    nhtsaId: "5200",
    name: "850CSi"
  }, {
    nhtsaId: "5217",
    name: "318ti"
  }, {
    nhtsaId: "5237",
    name: "328iC"
  }, {
    nhtsaId: "5238",
    name: "328iS"
  }, {
    nhtsaId: "5239",
    name: "Z3"
  }, {
    nhtsaId: "5253",
    name: "323i"
  }, {
    nhtsaId: "5254",
    name: "323is"
  }, {
    nhtsaId: "5255",
    name: "323iC"
  }, {
    nhtsaId: "5324",
    name: "Z8"
  }, {
    nhtsaId: "5343",
    name: "525iA"
  }, {
    nhtsaId: "5347",
    name: "530iA"
  }, {
    nhtsaId: "5348",
    name: "540iA"
  }, {
    nhtsaId: "5349",
    name: "525iAT"
  }, {
    nhtsaId: "5350",
    name: "540iAT"
  }, {
    nhtsaId: "5355",
    name: "Alpina"
  }, {
    nhtsaId: "5384",
    name: "645i"
  }, {
    nhtsaId: "5992",
    name: "X4"
  }, {
    nhtsaId: "9253",
    name: "335"
  }, {
    nhtsaId: "9452",
    name: "740iL"
  }, {
    nhtsaId: "9453",
    name: "750iL"
  }, {
    nhtsaId: "9459",
    name: "M3Ci"
  }, {
    nhtsaId: "9567",
    name: "M2"
  }, {
    nhtsaId: "9568",
    name: "340i"
  }, {
    nhtsaId: "9569",
    name: "330e"
  }, {
    nhtsaId: "9570",
    name: "M4"
  }, {
    nhtsaId: "10587",
    name: "328Ci"
  }, {
    nhtsaId: "13425",
    name: "735i"
  }, {
    nhtsaId: "13426",
    name: "735iL"
  }, {
    nhtsaId: "13427",
    name: "850i"
  }, {
    nhtsaId: "13429",
    name: "325ix"
  }, {
    nhtsaId: "13431",
    name: "325/325e"
  }, {
    nhtsaId: "13437",
    name: "635CSi"
  }, {
    nhtsaId: "13438",
    name: "535i/535is"
  }, {
    nhtsaId: "13439",
    name: "L7"
  }, {
    nhtsaId: "13442",
    name: "524td"
  }, {
    nhtsaId: "13448",
    name: "528e"
  }, {
    nhtsaId: "13449",
    name: "325e"
  }, {
    nhtsaId: "13459",
    name: "325i/325is"
  }, {
    nhtsaId: "13825",
    name: "230i"
  }, {
    nhtsaId: "13826",
    name: "M240i"
  }, {
    nhtsaId: "13827",
    name: "430i"
  }, {
    nhtsaId: "13828",
    name: "440i"
  }, {
    nhtsaId: "13835",
    name: "740e"
  }, {
    nhtsaId: "13868",
    name: "750i / ALPINA B7"
  }, {
    nhtsaId: "14503",
    name: "533i"
  }, {
    nhtsaId: "14504",
    name: "633 csi"
  }, {
    nhtsaId: "14505",
    name: "733i"
  }, {
    nhtsaId: "19172",
    name: "730i"
  }, {
    nhtsaId: "20811",
    name: "540d"
  }, {
    nhtsaId: "20813",
    name: "530e"
  }, {
    nhtsaId: "20814",
    name: "M550i"
  }, {
    nhtsaId: "20815",
    name: "M760i"
  }, {
    nhtsaId: "21787",
    name: "650i / ALPINA B6"
  }, {
    nhtsaId: "21788",
    name: "750Li / ALPINA B7"
  }, {
    nhtsaId: "21790",
    name: "750Lxi / ALPINA B7"
  }, {
    nhtsaId: "21791",
    name: "750xi / ALPINA B7"
  }, {
    nhtsaId: "21792",
    name: "750i / B7"
  }, {
    nhtsaId: "21793",
    name: "650i / B6"
  }, {
    nhtsaId: "24940",
    name: "X2"
  }, {
    nhtsaId: "24944",
    name: "640xi"
  }]
}, {
  nhtsaId: 468,
  makeId: "BUICK",
  name: "Buick",
  models: [{
    nhtsaId: "1821",
    name: "LaCrosse"
  }, {
    nhtsaId: "1822",
    name: "Regal"
  }, {
    nhtsaId: "1823",
    name: "Verano"
  }, {
    nhtsaId: "1841",
    name: "Enclave"
  }, {
    nhtsaId: "1842",
    name: "Encore"
  }, {
    nhtsaId: "4267",
    name: "Lucerne"
  }, {
    nhtsaId: "4287",
    name: "Allure"
  }, {
    nhtsaId: "4953",
    name: "Terraza"
  }, {
    nhtsaId: "4954",
    name: "Rainier"
  }, {
    nhtsaId: "4955",
    name: "Rendezvous"
  }, {
    nhtsaId: "8841",
    name: "Park Avenue"
  }, {
    nhtsaId: "8842",
    name: "LeSabre"
  }, {
    nhtsaId: "8843",
    name: "Century"
  }, {
    nhtsaId: "9026",
    name: "Incomplete"
  }, {
    nhtsaId: "9069",
    name: "Riviera"
  }, {
    nhtsaId: "9090",
    name: "Skylark"
  }, {
    nhtsaId: "9119",
    name: "Coachbuilder"
  }, {
    nhtsaId: "9120",
    name: "Roadmaster"
  }, {
    nhtsaId: "10290",
    name: "Cascada"
  }, {
    nhtsaId: "11438",
    name: "Envision"
  }, {
    nhtsaId: "14362",
    name: "Reatta"
  }, {
    nhtsaId: "14422",
    name: "Electra"
  }, {
    nhtsaId: "14466",
    name: "Skyhawk"
  }, {
    nhtsaId: "14486",
    name: "Somerset"
  }, {
    nhtsaId: "17844",
    name: "Regal TourX"
  }]
}, {
  nhtsaId: 469,
  makeId: "CAD",
  name: "Cadillac",
  models: [{
    nhtsaId: "1824",
    name: "ATS"
  }, {
    nhtsaId: "1825",
    name: "CTS"
  }, {
    nhtsaId: "1826",
    name: "ELR"
  }, {
    nhtsaId: "1827",
    name: "XTS"
  }, {
    nhtsaId: "1843",
    name: "Escalade"
  }, {
    nhtsaId: "1844",
    name: "SRX"
  }, {
    nhtsaId: "4300",
    name: "STS"
  }, {
    nhtsaId: "4308",
    name: "DTS"
  }, {
    nhtsaId: "4311",
    name: "XLR"
  }, {
    nhtsaId: "4592",
    name: "Limousine"
  }, {
    nhtsaId: "4593",
    name: "Hearse "
  }, {
    nhtsaId: "4935",
    name: "Escalade ESV"
  }, {
    nhtsaId: "8844",
    name: "Deville"
  }, {
    nhtsaId: "8989",
    name: "Eldorado"
  }, {
    nhtsaId: "9023",
    name: "Catera"
  }, {
    nhtsaId: "9091",
    name: "Seville"
  }, {
    nhtsaId: "9121",
    name: "Commercial Chassis"
  }, {
    nhtsaId: "9122",
    name: "Fleetwood"
  }, {
    nhtsaId: "10297",
    name: "CT6"
  }, {
    nhtsaId: "11442",
    name: "XT5"
  }, {
    nhtsaId: "14182",
    name: "60 Special"
  }, {
    nhtsaId: "14183",
    name: "Allante"
  }, {
    nhtsaId: "14185",
    name: "Brougham"
  }, {
    nhtsaId: "14487",
    name: "Cimarron"
  }, {
    nhtsaId: "24948",
    name: "XT4"
  }]
}, {
  nhtsaId: 467,
  makeId: "CHEVY",
  name: "Chevrolet",
  models: [{
    nhtsaId: "1828",
    name: "Aveo"
  }, {
    nhtsaId: "1829",
    name: "Camaro"
  }, {
    nhtsaId: "1830",
    name: "Caprice Police Vehicle"
  }, {
    nhtsaId: "1831",
    name: "Corvette"
  }, {
    nhtsaId: "1832",
    name: "Cruze"
  }, {
    nhtsaId: "1833",
    name: "Impala"
  }, {
    nhtsaId: "1834",
    name: "Malibu"
  }, {
    nhtsaId: "1835",
    name: "Sonic"
  }, {
    nhtsaId: "1836",
    name: "Spark"
  }, {
    nhtsaId: "1837",
    name: "SS"
  }, {
    nhtsaId: "1838",
    name: "Volt"
  }, {
    nhtsaId: "1846",
    name: "Captiva Sport"
  }, {
    nhtsaId: "1847",
    name: "Equinox"
  }, {
    nhtsaId: "1848",
    name: "Express"
  }, {
    nhtsaId: "1849",
    name: "Orlando"
  }, {
    nhtsaId: "1850",
    name: "Silverado"
  }, {
    nhtsaId: "1851",
    name: "Suburban"
  }, {
    nhtsaId: "1852",
    name: "Tahoe"
  }, {
    nhtsaId: "1853",
    name: "Traverse"
  }, {
    nhtsaId: "1854",
    name: "Tracker"
  }, {
    nhtsaId: "1921",
    name: "City Express"
  }, {
    nhtsaId: "3531",
    name: "Geo Prizm"
  }, {
    nhtsaId: "3876",
    name: "Avalanche"
  }, {
    nhtsaId: "4047",
    name: "Matiz"
  }, {
    nhtsaId: "4086",
    name: "Colorado"
  }, {
    nhtsaId: "4234",
    name: "Cobalt"
  }, {
    nhtsaId: "4251",
    name: "Optra"
  }, {
    nhtsaId: "4255",
    name: "Kalos"
  }, {
    nhtsaId: "4548",
    name: "Trailblazer"
  }, {
    nhtsaId: "4586",
    name: "HHR"
  }, {
    nhtsaId: "4588",
    name: "Uplander"
  }, {
    nhtsaId: "4773",
    name: "Monte Carlo"
  }, {
    nhtsaId: "4889",
    name: "SSR"
  }, {
    nhtsaId: "4992",
    name: "Epica"
  }, {
    nhtsaId: "8834",
    name: "Cavalier"
  }, {
    nhtsaId: "8835",
    name: "U100"
  }, {
    nhtsaId: "8881",
    name: "3 ton"
  }, {
    nhtsaId: "8882",
    name: "Astro Van"
  }, {
    nhtsaId: "8883",
    name: "Venture"
  }, {
    nhtsaId: "9016",
    name: "B7"
  }, {
    nhtsaId: "9064",
    name: "Lumina"
  }, {
    nhtsaId: "9088",
    name: "Alero"
  }, {
    nhtsaId: "9115",
    name: "Caprice"
  }, {
    nhtsaId: "9116",
    name: "Corsica"
  }, {
    nhtsaId: "9117",
    name: "Beretta"
  }, {
    nhtsaId: "9139",
    name: "Hearse/Limo"
  }, {
    nhtsaId: "10043",
    name: "Metro"
  }, {
    nhtsaId: "10978",
    name: "GMT-400"
  }, {
    nhtsaId: "10979",
    name: "Military Truck"
  }, {
    nhtsaId: "10983",
    name: "Forward Control"
  }, {
    nhtsaId: "10988",
    name: "Trax"
  }, {
    nhtsaId: "11483",
    name: "S-10 Pickup"
  }, {
    nhtsaId: "11489",
    name: "C/K Pickup"
  }, {
    nhtsaId: "11491",
    name: "P - Series"
  }, {
    nhtsaId: "11497",
    name: "Lumina APV"
  }, {
    nhtsaId: "11502",
    name: "Blazer"
  }, {
    nhtsaId: "13634",
    name: "Impala Limited"
  }, {
    nhtsaId: "13672",
    name: "Bolt EV"
  }, {
    nhtsaId: "14034",
    name: "C5"
  }, {
    nhtsaId: "14035",
    name: "C6"
  }, {
    nhtsaId: "14036",
    name: "C7"
  }, {
    nhtsaId: "14166",
    name: "Hearse/Limo Commercial Chassis"
  }, {
    nhtsaId: "14452",
    name: "P6S"
  }, {
    nhtsaId: "14457",
    name: "S-10"
  }, {
    nhtsaId: "14460",
    name: "Celebrity"
  }, {
    nhtsaId: "14461",
    name: "Geo Spectrum"
  }, {
    nhtsaId: "14462",
    name: "G-Series"
  }, {
    nhtsaId: "14464",
    name: "Cutaway Chassis"
  }, {
    nhtsaId: "14465",
    name: "Motorhome Chassis"
  }, {
    nhtsaId: "14475",
    name: "Chevette"
  }, {
    nhtsaId: "14501",
    name: "Hi-Cube"
  }, {
    nhtsaId: "14506",
    name: "S7"
  }, {
    nhtsaId: "14513",
    name: "Geo Sprint"
  }, {
    nhtsaId: "14515",
    name: "Nova"
  }, {
    nhtsaId: "14544",
    name: "S6"
  }, {
    nhtsaId: "14545",
    name: "R Conventional"
  }, {
    nhtsaId: "14546",
    name: "V Conventional"
  }, {
    nhtsaId: "14547",
    name: "Citation"
  }, {
    nhtsaId: "14616",
    name: "Bus Chassis"
  }, {
    nhtsaId: "14617",
    name: "Heavy Conventional"
  }, {
    nhtsaId: "14619",
    name: "Aluminum Tilt"
  }, {
    nhtsaId: "14637",
    name: "El Camino"
  }, {
    nhtsaId: "15634",
    name: "LUV"
  }, {
    nhtsaId: "17528",
    name: "Malibu Classic"
  }, {
    nhtsaId: "24906",
    name: "Silverado HD"
  }, {
    nhtsaId: "25279",
    name: "Silverado LD"
  }]
}, {
  nhtsaId: 477,
  makeId: "CHRY",
  name: "Chrysler",
  models: [{
    nhtsaId: "1876",
    name: "Cirrus"
  }, {
    nhtsaId: "1877",
    name: "Sebring"
  }, {
    nhtsaId: "1878",
    name: "300"
  }, {
    nhtsaId: "1936",
    name: "Town and Country"
  }, {
    nhtsaId: "1937",
    name: "Grand Voyager"
  }, {
    nhtsaId: "2053",
    name: "200"
  }, {
    nhtsaId: "3595",
    name: "PT Cruiser"
  }, {
    nhtsaId: "3598",
    name: "Crossfire"
  }, {
    nhtsaId: "3628",
    name: "Pacifica"
  }, {
    nhtsaId: "3629",
    name: "Aspen"
  }, {
    nhtsaId: "5875",
    name: "Concorde"
  }, {
    nhtsaId: "5876",
    name: "Intrepid"
  }, {
    nhtsaId: "6470",
    name: "New Yorker"
  }, {
    nhtsaId: "6475",
    name: "LHS"
  }, {
    nhtsaId: "6476",
    name: "Vision"
  }, {
    nhtsaId: "6480",
    name: "Stratus"
  }, {
    nhtsaId: "6483",
    name: "Viper"
  }, {
    nhtsaId: "6485",
    name: "Neon"
  }, {
    nhtsaId: "6488",
    name: "Shadow"
  }, {
    nhtsaId: "6813",
    name: "Prowler"
  }, {
    nhtsaId: "7053",
    name: "Caravan"
  }, {
    nhtsaId: "14338",
    name: "TC"
  }, {
    nhtsaId: "14344",
    name: "LeBaron"
  }, {
    nhtsaId: "14345",
    name: "Concorde/LHS"
  }, {
    nhtsaId: "14371",
    name: "Daytona"
  }, {
    nhtsaId: "14372",
    name: "Dynasty"
  }, {
    nhtsaId: "14373",
    name: "Imperial"
  }, {
    nhtsaId: "14400",
    name: "SALON"
  }, {
    nhtsaId: "14411",
    name: "LASER"
  }, {
    nhtsaId: "14412",
    name: "NEWPORT"
  }, {
    nhtsaId: "14413",
    name: "FIFTH AVENUE"
  }, {
    nhtsaId: "14439",
    name: "Conquest"
  }, {
    nhtsaId: "14574",
    name: "EXECUTIVE"
  }, {
    nhtsaId: "14575",
    name: "E-CLASS"
  }, {
    nhtsaId: "14699",
    name: "Cordoba"
  }, {
    nhtsaId: "15131",
    name: "Voyager"
  }, {
    nhtsaId: "25754",
    name: "300C"
  }]
}, {
  nhtsaId: 1077,
  makeId: "DAEW",
  name: "Daewoo",
  models: [{
    nhtsaId: "14902",
    name: "LANOS"
  }, {
    nhtsaId: "14903",
    name: "NUBIRA"
  }, {
    nhtsaId: "14904",
    name: "LEGANZA"
  }, {
    nhtsaId: "23793",
    name: "Laganza V-car"
  }, {
    nhtsaId: "23794",
    name: "Leganza V-200 & variants/derivatives"
  }]
}, {
  nhtsaId: 847,
  makeId: "DAIHAT",
  name: "Daihatsu",
  models: [{
    nhtsaId: "12954",
    name: "Charade"
  }, {
    nhtsaId: "12955",
    name: "Rocky"
  }]
}, {
  nhtsaId: 5657,
  makeId: "DATSUN",
  name: "Datsun",
  models: [{
    nhtsaId: "14563",
    name: "210"
  }, {
    nhtsaId: "14564",
    name: "310"
  }, {
    nhtsaId: "14565",
    name: "510"
  }, {
    nhtsaId: "14566",
    name: "200SX"
  }, {
    nhtsaId: "14567",
    name: "280ZX"
  }, {
    nhtsaId: "17882",
    name: "Honeybee"
  }]
}, {
  nhtsaId: 476,
  makeId: "DODGE",
  name: "Dodge",
  models: [{
    nhtsaId: "1892",
    name: "Avenger"
  }, {
    nhtsaId: "1893",
    name: "Challenger"
  }, {
    nhtsaId: "1895",
    name: "Charger"
  }, {
    nhtsaId: "1896",
    name: "Caliber"
  }, {
    nhtsaId: "1897",
    name: "Viper"
  }, {
    nhtsaId: "1938",
    name: "Ram"
  }, {
    nhtsaId: "1939",
    name: "Journey"
  }, {
    nhtsaId: "1940",
    name: "Nitro"
  }, {
    nhtsaId: "1941",
    name: "Dakota"
  }, {
    nhtsaId: "1942",
    name: "Caravan/Grand Caravan"
  }, {
    nhtsaId: "1958",
    name: "Ram Chassis Cab"
  }, {
    nhtsaId: "2054",
    name: "Dart"
  }, {
    nhtsaId: "3121",
    name: "Sprinter"
  }, {
    nhtsaId: "3508",
    name: "Durango"
  }, {
    nhtsaId: "3510",
    name: "Chassis with Powertrain"
  }, {
    nhtsaId: "3680",
    name: "Magnum"
  }, {
    nhtsaId: "5878",
    name: "Intrepid"
  }, {
    nhtsaId: "5879",
    name: "Stratus"
  }, {
    nhtsaId: "5880",
    name: "Neon"
  }, {
    nhtsaId: "6250",
    name: "Colt"
  }, {
    nhtsaId: "6254",
    name: "Stealth"
  }, {
    nhtsaId: "6356",
    name: "Ramcharger"
  }, {
    nhtsaId: "10962",
    name: "Ram Van"
  }, {
    nhtsaId: "10963",
    name: "Ram Wagon"
  }, {
    nhtsaId: "14351",
    name: "Spirit"
  }, {
    nhtsaId: "14363",
    name: "SHADOW"
  }, {
    nhtsaId: "14375",
    name: "Dynasty"
  }, {
    nhtsaId: "14376",
    name: "Daytona"
  }, {
    nhtsaId: "14389",
    name: "Monaco"
  }, {
    nhtsaId: "14402",
    name: "OMNI"
  }, {
    nhtsaId: "14414",
    name: "SHELBY"
  }, {
    nhtsaId: "14415",
    name: "ARIES"
  }, {
    nhtsaId: "14416",
    name: "600"
  }, {
    nhtsaId: "14417",
    name: "DIPLOMAT"
  }, {
    nhtsaId: "14418",
    name: "LANCER"
  }, {
    nhtsaId: "14419",
    name: "Conquest"
  }, {
    nhtsaId: "14766",
    name: "400"
  }, {
    nhtsaId: "14767",
    name: "Mirada"
  }, {
    nhtsaId: "14772",
    name: "ST.REGIS"
  }, {
    nhtsaId: "14831",
    name: "Caravan"
  }, {
    nhtsaId: "14832",
    name: "Grand Caravan"
  }, {
    nhtsaId: "14864",
    name: "RAM 50"
  }, {
    nhtsaId: "14868",
    name: "D-Series"
  }, {
    nhtsaId: "14869",
    name: "W-Series"
  }, {
    nhtsaId: "14939",
    name: "Raider"
  }, {
    nhtsaId: "14969",
    name: "Mini Ram"
  }, {
    nhtsaId: "15003",
    name: "Royal Mini Ram Van"
  }, {
    nhtsaId: "15056",
    name: "D50"
  }, {
    nhtsaId: "15083",
    name: "Rampage"
  }, {
    nhtsaId: "15124",
    name: "RD200 / RD250"
  }]
}, {
  nhtsaId: 2408,
  makeId: "EAGLE",
  name: "Eagle",
  models: [{
    nhtsaId: "6268",
    name: "Summit"
  }, {
    nhtsaId: "6269",
    name: "Talon"
  }, {
    nhtsaId: "6494",
    name: "Vision"
  }, {
    nhtsaId: "14384",
    name: "2000 GTX"
  }, {
    nhtsaId: "14390",
    name: "PREMIER"
  }, {
    nhtsaId: "14391",
    name: "VISTA"
  }, {
    nhtsaId: "17415",
    name: "MEDALLION"
  }]
}, {
  nhtsaId: 603,
  makeId: "FER",
  name: "Ferrari",
  models: [{
    nhtsaId: "3601",
    name: "612 Scaglietti"
  }, {
    nhtsaId: "3602",
    name: "F430 Coupe"
  }, {
    nhtsaId: "3603",
    name: "599 GTB"
  }, {
    nhtsaId: "3604",
    name: "F430 Spider"
  }, {
    nhtsaId: "3605",
    name: "599 GTB Fiorano"
  }, {
    nhtsaId: "3606",
    name: "430 Scuderia"
  }, {
    nhtsaId: "3607",
    name: "F430"
  }, {
    nhtsaId: "3635",
    name: "430 Scuderia Spider"
  }, {
    nhtsaId: "9939",
    name: "360 Modena/360 Modena F1"
  }, {
    nhtsaId: "9940",
    name: "360 Spider/360 Spider F1"
  }, {
    nhtsaId: "9941",
    name: "575 M Maranello/575 M Maranello F1"
  }, {
    nhtsaId: "9942",
    name: "456 MGT"
  }, {
    nhtsaId: "9943",
    name: "456 MGTA"
  }, {
    nhtsaId: "9944",
    name: "Enzo"
  }, {
    nhtsaId: "9954",
    name: "F355"
  }, {
    nhtsaId: "9957",
    name: "550 Maranello"
  }, {
    nhtsaId: "13843",
    name: "F12 Berlinetta"
  }, {
    nhtsaId: "13849",
    name: "California T"
  }, {
    nhtsaId: "13850",
    name: "FF"
  }, {
    nhtsaId: "13851",
    name: "La Ferrari"
  }, {
    nhtsaId: "13852",
    name: "458 Italia"
  }, {
    nhtsaId: "13853",
    name: "458 Speciale"
  }, {
    nhtsaId: "13854",
    name: "458 Speciale Spider"
  }, {
    nhtsaId: "13855",
    name: "458 Spider"
  }, {
    nhtsaId: "13856",
    name: "California"
  }, {
    nhtsaId: "13872",
    name: "599 GTO"
  }, {
    nhtsaId: "14016",
    name: "348 tb"
  }, {
    nhtsaId: "14017",
    name: "348 ts"
  }, {
    nhtsaId: "14020",
    name: "512 TR"
  }, {
    nhtsaId: "14024",
    name: "355 Berlinetta"
  }, {
    nhtsaId: "14025",
    name: "355 GTS"
  }, {
    nhtsaId: "14026",
    name: "348 Spider"
  }, {
    nhtsaId: "14027",
    name: "456 GT"
  }, {
    nhtsaId: "14028",
    name: "355 Spider"
  }, {
    nhtsaId: "14031",
    name: "Mondial T"
  }, {
    nhtsaId: "14038",
    name: "Testarossa"
  }, {
    nhtsaId: "14039",
    name: "F40"
  }, {
    nhtsaId: "14047",
    name: "328 GTB"
  }, {
    nhtsaId: "14048",
    name: "328 GTS"
  }, {
    nhtsaId: "14049",
    name: "3.2 Mondial"
  }, {
    nhtsaId: "14050",
    name: "328"
  }, {
    nhtsaId: "14052",
    name: "308GTB Quattrovalvole"
  }, {
    nhtsaId: "14053",
    name: "308GTS Quattrovalvole"
  }, {
    nhtsaId: "14055",
    name: "Mondial 8"
  }, {
    nhtsaId: "14056",
    name: "308 Convertible"
  }, {
    nhtsaId: "14111",
    name: "488 GTB"
  }, {
    nhtsaId: "14112",
    name: "488 GTS"
  }, {
    nhtsaId: "14113",
    name: "F12 Special Series"
  }, {
    nhtsaId: "14114",
    name: "F60 America"
  }, {
    nhtsaId: "14598",
    name: "308GTBi"
  }, {
    nhtsaId: "14599",
    name: "308GTSi"
  }, {
    nhtsaId: "14600",
    name: "308GTB"
  }, {
    nhtsaId: "14601",
    name: "308GTS"
  }, {
    nhtsaId: "25180",
    name: "F12 tdf (Tour de France)"
  }, {
    nhtsaId: "25181",
    name: "GTC4Lusso"
  }]
}, {
  nhtsaId: 492,
  makeId: "FIAT",
  name: "Fiat",
  models: [{
    nhtsaId: "2037",
    name: "500L"
  }, {
    nhtsaId: "2055",
    name: "500"
  }, {
    nhtsaId: "3490",
    name: "Freemont"
  }, {
    nhtsaId: "10396",
    name: "500X"
  }, {
    nhtsaId: "11448",
    name: "124 Spider"
  }, {
    nhtsaId: "14603",
    name: "Spider 2000"
  }, {
    nhtsaId: "14604",
    name: "X 1/9"
  }, {
    nhtsaId: "14605",
    name: "Brava"
  }, {
    nhtsaId: "14606",
    name: "Strada"
  }, {
    nhtsaId: "25128",
    name: "Ducato"
  }]
}, {
  nhtsaId: 1033,
  makeId: "FISK",
  name: "FISKER AUTOMOTIVE",
  models: [{
    nhtsaId: "4277",
    name: "Karma"
  }]
}, {
  nhtsaId: 460,
  makeId: "FORD",
  name: "Ford",
  models: [{
    nhtsaId: "1778",
    name: "Crown Victoria"
  }, {
    nhtsaId: "1779",
    name: "Focus"
  }, {
    nhtsaId: "1780",
    name: "Fusion"
  }, {
    nhtsaId: "1781",
    name: "Mustang"
  }, {
    nhtsaId: "1782",
    name: "Taurus"
  }, {
    nhtsaId: "1796",
    name: "E-150"
  }, {
    nhtsaId: "1797",
    name: "Edge"
  }, {
    nhtsaId: "1798",
    name: "Escape"
  }, {
    nhtsaId: "1799",
    name: "Expedition"
  }, {
    nhtsaId: "1800",
    name: "Explorer"
  }, {
    nhtsaId: "1801",
    name: "F-150"
  }, {
    nhtsaId: "1802",
    name: "Flex"
  }, {
    nhtsaId: "1803",
    name: "Ranger"
  }, {
    nhtsaId: "1804",
    name: "Explorer Sport Trac"
  }, {
    nhtsaId: "1805",
    name: "F-250"
  }, {
    nhtsaId: "1806",
    name: "F-350"
  }, {
    nhtsaId: "1807",
    name: "F-450"
  }, {
    nhtsaId: "1808",
    name: "F-550"
  }, {
    nhtsaId: "1809",
    name: "F-650"
  }, {
    nhtsaId: "1810",
    name: "F-750"
  }, {
    nhtsaId: "1811",
    name: "Transit Connect"
  }, {
    nhtsaId: "1817",
    name: "E-250"
  }, {
    nhtsaId: "1818",
    name: "E-350"
  }, {
    nhtsaId: "1819",
    name: "E-450"
  }, {
    nhtsaId: "1820",
    name: "Expedition MAX"
  }, {
    nhtsaId: "2345",
    name: "Thunderbird"
  }, {
    nhtsaId: "2346",
    name: "GT"
  }, {
    nhtsaId: "2347",
    name: "Five Hundred"
  }, {
    nhtsaId: "2370",
    name: "Excursion"
  }, {
    nhtsaId: "2379",
    name: "Freestyle"
  }, {
    nhtsaId: "2384",
    name: "Freestar"
  }, {
    nhtsaId: "2737",
    name: "Motorhome Chassis"
  }, {
    nhtsaId: "3160",
    name: "Taurus X"
  }, {
    nhtsaId: "3267",
    name: "Fiesta"
  }, {
    nhtsaId: "3462",
    name: "C-max"
  }, {
    nhtsaId: "3608",
    name: "Transit"
  }, {
    nhtsaId: "5181",
    name: "Escort"
  }, {
    nhtsaId: "5182",
    name: "ZX2"
  }, {
    nhtsaId: "5264",
    name: "Windstar"
  }, {
    nhtsaId: "5342",
    name: "E-550"
  }, {
    nhtsaId: "5346",
    name: "B-750"
  }, {
    nhtsaId: "5361",
    name: "F-800"
  }, {
    nhtsaId: "5868",
    name: "Explorer Sport"
  }, {
    nhtsaId: "6703",
    name: "Aspire"
  }, {
    nhtsaId: "6730",
    name: "Probe"
  }, {
    nhtsaId: "6731",
    name: "Contour"
  }, {
    nhtsaId: "6825",
    name: "Bronco"
  }, {
    nhtsaId: "6857",
    name: "Aerostar"
  }, {
    nhtsaId: "7331",
    name: "F-150 Heritage"
  }, {
    nhtsaId: "9213",
    name: "L8501"
  }, {
    nhtsaId: "9214",
    name: "LT8501"
  }, {
    nhtsaId: "9215",
    name: "L9501"
  }, {
    nhtsaId: "9216",
    name: "LT9501"
  }, {
    nhtsaId: "9217",
    name: "L8511"
  }, {
    nhtsaId: "9218",
    name: "LT8511"
  }, {
    nhtsaId: "9219",
    name: "L9511"
  }, {
    nhtsaId: "9220",
    name: "LT9511"
  }, {
    nhtsaId: "9221",
    name: "L8513"
  }, {
    nhtsaId: "9222",
    name: "LT8513"
  }, {
    nhtsaId: "9223",
    name: "L9513"
  }, {
    nhtsaId: "9224",
    name: "LT9513"
  }, {
    nhtsaId: "9225",
    name: "L9522"
  }, {
    nhtsaId: "9226",
    name: "LT9522"
  }, {
    nhtsaId: "9227",
    name: "A8513"
  }, {
    nhtsaId: "9228",
    name: "AT8513"
  }, {
    nhtsaId: "9229",
    name: "A9513"
  }, {
    nhtsaId: "9230",
    name: "AT9513"
  }, {
    nhtsaId: "9231",
    name: "A9522"
  }, {
    nhtsaId: "9232",
    name: "AT9522"
  }, {
    nhtsaId: "9268",
    name: "B800"
  }, {
    nhtsaId: "9270",
    name: "F-Super Duty"
  }, {
    nhtsaId: "9272",
    name: "F-700"
  }, {
    nhtsaId: "9282",
    name: "P700"
  }, {
    nhtsaId: "9283",
    name: "P800"
  }, {
    nhtsaId: "9284",
    name: "FT900"
  }, {
    nhtsaId: "9285",
    name: "L8000"
  }, {
    nhtsaId: "9286",
    name: "L9000"
  }, {
    nhtsaId: "9287",
    name: "LL9000"
  }, {
    nhtsaId: "9288",
    name: "LLA9000"
  }, {
    nhtsaId: "9289",
    name: "LLS9000"
  }, {
    nhtsaId: "9290",
    name: "LS8000"
  }, {
    nhtsaId: "9291",
    name: "LS9000"
  }, {
    nhtsaId: "9292",
    name: "LT8000"
  }, {
    nhtsaId: "9293",
    name: "LT9000"
  }, {
    nhtsaId: "9294",
    name: "LTS8000"
  }, {
    nhtsaId: "9295",
    name: "LTS9000"
  }, {
    nhtsaId: "9296",
    name: "LTL9000"
  }, {
    nhtsaId: "9297",
    name: "LTLA9000"
  }, {
    nhtsaId: "9298",
    name: "LTLS9000"
  }, {
    nhtsaId: "9299",
    name: "LA8000"
  }, {
    nhtsaId: "9300",
    name: "LA9000"
  }, {
    nhtsaId: "9301",
    name: "LTA9000"
  }, {
    nhtsaId: "9302",
    name: "LN7000"
  }, {
    nhtsaId: "9303",
    name: "LN8000"
  }, {
    nhtsaId: "9304",
    name: "LN9000"
  }, {
    nhtsaId: "9305",
    name: "LNT8000"
  }, {
    nhtsaId: "9306",
    name: "LNT9000"
  }, {
    nhtsaId: "9307",
    name: "CF8000"
  }, {
    nhtsaId: "9308",
    name: "CFT8000"
  }, {
    nhtsaId: "9312",
    name: "CF7000"
  }, {
    nhtsaId: "10378",
    name: "Festiva"
  }, {
    nhtsaId: "13958",
    name: "Tempo"
  }, {
    nhtsaId: "13977",
    name: "B600"
  }, {
    nhtsaId: "13978",
    name: "B700"
  }, {
    nhtsaId: "13979",
    name: "F-600"
  }, {
    nhtsaId: "13980",
    name: "Recreational Vehicle"
  }, {
    nhtsaId: "13981",
    name: "F-590"
  }, {
    nhtsaId: "13983",
    name: "P600"
  }, {
    nhtsaId: "14148",
    name: "CL9000"
  }, {
    nhtsaId: "14149",
    name: "CLT9000"
  }, {
    nhtsaId: "14150",
    name: "Bronco II"
  }, {
    nhtsaId: "14152",
    name: "FT800"
  }, {
    nhtsaId: "14153",
    name: "CT8000"
  }, {
    nhtsaId: "14154",
    name: "C800"
  }, {
    nhtsaId: "14155",
    name: "C8000"
  }, {
    nhtsaId: "14196",
    name: "Laser"
  }, {
    nhtsaId: "14199",
    name: "LTD"
  }, {
    nhtsaId: "14614",
    name: "Fairmont"
  }, {
    nhtsaId: "14618",
    name: "Granada"
  }, {
    nhtsaId: "14930",
    name: "'34 "
  }, {
    nhtsaId: "15160",
    name: "CF6000"
  }, {
    nhtsaId: "15194",
    name: "B7000"
  }, {
    nhtsaId: "15195",
    name: "C7000"
  }, {
    nhtsaId: "15197",
    name: "F7000"
  }, {
    nhtsaId: "15198",
    name: "F8000"
  }, {
    nhtsaId: "15203",
    name: "FT8000"
  }, {
    nhtsaId: "15204",
    name: "Courier"
  }, {
    nhtsaId: "15205",
    name: "B6000"
  }, {
    nhtsaId: "15206",
    name: "C600"
  }, {
    nhtsaId: "15208",
    name: "C700"
  }, {
    nhtsaId: "15209",
    name: "F6000"
  }, {
    nhtsaId: "15223",
    name: "LN600"
  }, {
    nhtsaId: "15225",
    name: "LN700"
  }, {
    nhtsaId: "15251",
    name: "L800"
  }, {
    nhtsaId: "15252",
    name: "LT800"
  }, {
    nhtsaId: "15254",
    name: "LN800"
  }, {
    nhtsaId: "15255",
    name: "LNT800"
  }, {
    nhtsaId: "15273",
    name: "E-100"
  }, {
    nhtsaId: "15280",
    name: "F-100"
  }, {
    nhtsaId: "15291",
    name: "CT800"
  }, {
    nhtsaId: "17774",
    name: "Ecosport"
  }, {
    nhtsaId: "25742",
    name: "Expedition EL"
  }]
}, {
  nhtsaId: 450,
  makeId: "FREIGHT",
  name: "Freightliner",
  models: [{
    nhtsaId: "1704",
    name: "Sprinter"
  }, {
    nhtsaId: "1972",
    name: "MB Chassis"
  }, {
    nhtsaId: "1974",
    name: "XC Chassis"
  }, {
    nhtsaId: "1976",
    name: "VCL Chassis "
  }, {
    nhtsaId: "1977",
    name: "MT 35 Chassis"
  }, {
    nhtsaId: "1978",
    name: "MT 45 Chassis"
  }, {
    nhtsaId: "1979",
    name: "MT 55 Chassis"
  }, {
    nhtsaId: "1981",
    name: "XB Chassis"
  }, {
    nhtsaId: "1982",
    name: "FS 65 Chassis"
  }, {
    nhtsaId: "2470",
    name: "FLB"
  }, {
    nhtsaId: "2479",
    name: "Argosy"
  }, {
    nhtsaId: "2480",
    name: "C112"
  }, {
    nhtsaId: "2481",
    name: "C120"
  }, {
    nhtsaId: "2482",
    name: "Columbia"
  }, {
    nhtsaId: "2483",
    name: "CST112"
  }, {
    nhtsaId: "2484",
    name: "FLD112"
  }, {
    nhtsaId: "2485",
    name: "FLD120"
  }, {
    nhtsaId: "2486",
    name: "FLD132"
  }, {
    nhtsaId: "2487",
    name: "FL112"
  }, {
    nhtsaId: "2488",
    name: "FL50"
  }, {
    nhtsaId: "2489",
    name: "FL60"
  }, {
    nhtsaId: "2490",
    name: "FL70"
  }, {
    nhtsaId: "2491",
    name: "FL80"
  }, {
    nhtsaId: "2492",
    name: "FL106"
  }, {
    nhtsaId: "2493",
    name: "FC70"
  }, {
    nhtsaId: "2494",
    name: "FC80"
  }, {
    nhtsaId: "2495",
    name: "RIV"
  }, {
    nhtsaId: "2496",
    name: "Sport Chassis"
  }, {
    nhtsaId: "2497",
    name: "Condor"
  }, {
    nhtsaId: "2498",
    name: "Coronado"
  }, {
    nhtsaId: "2499",
    name: "M2"
  }, {
    nhtsaId: "2500",
    name: "Classic"
  }, {
    nhtsaId: "2501",
    name: "Cascadia"
  }, {
    nhtsaId: "2502",
    name: "MD109"
  }, {
    nhtsaId: "2504",
    name: "114SD"
  }, {
    nhtsaId: "2505",
    name: "108SD"
  }, {
    nhtsaId: "2742",
    name: "CST120"
  }, {
    nhtsaId: "2768",
    name: "FLS112 Legacy"
  }, {
    nhtsaId: "5760",
    name: "Unimog"
  }, {
    nhtsaId: "9589",
    name: "Freightliner"
  }, {
    nhtsaId: "9590",
    name: "MC Chassis"
  }, {
    nhtsaId: "9591",
    name: "VC Chassis"
  }, {
    nhtsaId: "9592",
    name: "SBFD"
  }, {
    nhtsaId: "9593",
    name: "SBRD Chassis"
  }, {
    nhtsaId: "9804",
    name: "USF-1E"
  }, {
    nhtsaId: "9805",
    name: "High COE"
  }, {
    nhtsaId: "9806",
    name: "Long Conv."
  }, {
    nhtsaId: "9807",
    name: "Med. Conv."
  }, {
    nhtsaId: "9808",
    name: "MB60"
  }, {
    nhtsaId: "9809",
    name: "MB70"
  }, {
    nhtsaId: "9810",
    name: "MB80"
  }, {
    nhtsaId: "9811",
    name: "Low COE"
  }, {
    nhtsaId: "10462",
    name: "XCS Chassis"
  }, {
    nhtsaId: "13805",
    name: 'New Cascadia 126" Sleepercab'
  }, {
    nhtsaId: "13806",
    name: 'New Cascadia 126" Day cab'
  }, {
    nhtsaId: "13807",
    name: 'New Cascadia 116" Sleepercab'
  }, {
    nhtsaId: "13808",
    name: 'New Cascadia 116" Day cab'
  }, {
    nhtsaId: "13816",
    name: "SD122"
  }, {
    nhtsaId: "15784",
    name: "C.O.E."
  }, {
    nhtsaId: "15785",
    name: "Conventional"
  }, {
    nhtsaId: "17999",
    name: "CC Conventional"
  }, {
    nhtsaId: "18003",
    name: "FC60"
  }, {
    nhtsaId: "18004",
    name: "MB 50"
  }]
}, {
  nhtsaId: 1146,
  makeId: "GEO",
  name: "Geo",
  models: [{
    nhtsaId: "13905",
    name: "Metro"
  }, {
    nhtsaId: "14167",
    name: "Storm"
  }, {
    nhtsaId: "14168",
    name: "Prizm"
  }, {
    nhtsaId: "14483",
    name: "Tracker"
  }, {
    nhtsaId: "21535",
    name: "Sprint"
  }, {
    nhtsaId: "22098",
    name: "Spectrum"
  }]
}, {
  nhtsaId: 472,
  makeId: "GMC",
  name: "GMC",
  models: [{
    nhtsaId: "1855",
    name: "Acadia"
  }, {
    nhtsaId: "1856",
    name: "Savana"
  }, {
    nhtsaId: "1857",
    name: "Sierra"
  }, {
    nhtsaId: "1858",
    name: "Terrain"
  }, {
    nhtsaId: "1859",
    name: "Yukon"
  }, {
    nhtsaId: "4093",
    name: "Canyon"
  }, {
    nhtsaId: "4507",
    name: "Envoy"
  }, {
    nhtsaId: "4579",
    name: "Yukon XL"
  }, {
    nhtsaId: "8879",
    name: "Safari"
  }, {
    nhtsaId: "9044",
    name: "Electric Vehicle"
  }, {
    nhtsaId: "10985",
    name: "GMT-400"
  }, {
    nhtsaId: "11073",
    name: "Sonoma"
  }, {
    nhtsaId: "11488",
    name: "Suburban"
  }, {
    nhtsaId: "11490",
    name: "C/K Pickup"
  }, {
    nhtsaId: "11503",
    name: "Jimmy Utility"
  }, {
    nhtsaId: "14019",
    name: "C5"
  }, {
    nhtsaId: "14021",
    name: "C6"
  }, {
    nhtsaId: "14022",
    name: "C7"
  }, {
    nhtsaId: "14469",
    name: "P Truck Forward"
  }, {
    nhtsaId: "14470",
    name: "Motorhome Chassis"
  }, {
    nhtsaId: "14476",
    name: "S15 Utility"
  }, {
    nhtsaId: "14479",
    name: "Vandura"
  }, {
    nhtsaId: "14480",
    name: "Cutaway Van"
  }, {
    nhtsaId: "14481",
    name: "Rally"
  }, {
    nhtsaId: "14497",
    name: "Magna Van"
  }, {
    nhtsaId: "14499",
    name: "Value Van"
  }, {
    nhtsaId: "14500",
    name: "Hi-Cube"
  }, {
    nhtsaId: "14533",
    name: "Geo Tracker"
  }, {
    nhtsaId: "14535",
    name: "S6"
  }, {
    nhtsaId: "14536",
    name: "Jimmy"
  }, {
    nhtsaId: "14538",
    name: "R Conventional"
  }, {
    nhtsaId: "14539",
    name: "V Conventional"
  }, {
    nhtsaId: "14554",
    name: "S15 Pickup"
  }, {
    nhtsaId: "14555",
    name: "Forward Control"
  }, {
    nhtsaId: "14571",
    name: "Aluminum Tilt"
  }, {
    nhtsaId: "14596",
    name: "Heavy Conventional"
  }, {
    nhtsaId: "14602",
    name: "Bus Chassis"
  }, {
    nhtsaId: "14626",
    name: "Caballero"
  }, {
    nhtsaId: "24909",
    name: "Sierra HD"
  }, {
    nhtsaId: "24910",
    name: "Sierra Limited"
  }]
}, {
  nhtsaId: 474,
  makeId: "HONDA",
  name: "Honda",
  models: [{
    nhtsaId: "1861",
    name: "Accord"
  }, {
    nhtsaId: "1863",
    name: "Civic"
  }, {
    nhtsaId: "1864",
    name: "Pilot"
  }, {
    nhtsaId: "1865",
    name: "CR-V"
  }, {
    nhtsaId: "1866",
    name: "Ridgeline"
  }, {
    nhtsaId: "1868",
    name: "Element"
  }, {
    nhtsaId: "1869",
    name: "Odyssey"
  }, {
    nhtsaId: "1870",
    name: "Insight"
  }, {
    nhtsaId: "1875",
    name: "FCX Clarity"
  }, {
    nhtsaId: "2127",
    name: "Fit"
  }, {
    nhtsaId: "2128",
    name: "CR-Z"
  }, {
    nhtsaId: "3153",
    name: "S2000"
  }, {
    nhtsaId: "5107",
    name: "Prelude"
  }, {
    nhtsaId: "5959",
    name: "Passport"
  }, {
    nhtsaId: "9173",
    name: "Crosstour"
  }, {
    nhtsaId: "9212",
    name: "HR-V"
  }, {
    nhtsaId: "9577",
    name: "del Sol"
  }, {
    nhtsaId: "11517",
    name: "EV Plus"
  }, {
    nhtsaId: "14249",
    name: "CLARITY"
  }, {
    nhtsaId: "18584",
    name: "Civic Si / Civic Si HPT"
  }]
}, {
  nhtsaId: 498,
  makeId: "HYUND",
  name: "Hyundai",
  models: [{
    nhtsaId: "2056",
    name: "Equus"
  }, {
    nhtsaId: "2057",
    name: "Santa Fe"
  }, {
    nhtsaId: "2058",
    name: "Tucson"
  }, {
    nhtsaId: "2298",
    name: "Veloster"
  }, {
    nhtsaId: "2458",
    name: "Genesis Coupe"
  }, {
    nhtsaId: "2459",
    name: "Sonata"
  }, {
    nhtsaId: "2735",
    name: "Elantra"
  }, {
    nhtsaId: "2736",
    name: "Entourage"
  }, {
    nhtsaId: "2771",
    name: "Azera"
  }, {
    nhtsaId: "2772",
    name: "Veracruz"
  }, {
    nhtsaId: "2773",
    name: "Accent"
  }, {
    nhtsaId: "2774",
    name: "Genesis"
  }, {
    nhtsaId: "5847",
    name: "Tiburon"
  }, {
    nhtsaId: "5871",
    name: "Elantra Touring"
  }, {
    nhtsaId: "5872",
    name: "XG 350"
  }, {
    nhtsaId: "9242",
    name: "Excel"
  }, {
    nhtsaId: "9252",
    name: "Scoupe"
  }, {
    nhtsaId: "9271",
    name: "Elantra, Tiburon"
  }, {
    nhtsaId: "9319",
    name: "XG300"
  }, {
    nhtsaId: "11447",
    name: "Elantra GT"
  }, {
    nhtsaId: "13617",
    name: "Ioniq Electric"
  }, {
    nhtsaId: "13869",
    name: "Ioniq Hybrid"
  }, {
    nhtsaId: "14192",
    name: "Pony"
  }, {
    nhtsaId: "14193",
    name: "Stellar"
  }, {
    nhtsaId: "16649",
    name: "Elantra (ADa)"
  }, {
    nhtsaId: "16694",
    name: "Santa Fe Sport "
  }, {
    nhtsaId: "21961",
    name: "Ioniq Electric (EV), Hybrid (HEV, PHEV)"
  }, {
    nhtsaId: "22249",
    name: "Kona"
  }, {
    nhtsaId: "24770",
    name: "Santa Fe XL"
  }, {
    nhtsaId: "25183",
    name: "Nexo"
  }, {
    nhtsaId: "25847",
    name: "Palisade"
  }]
}, {
  nhtsaId: 480,
  makeId: "INFIN",
  name: "Infiniti",
  models: [{
    nhtsaId: "1899",
    name: "QX50"
  }, {
    nhtsaId: "1900",
    name: "Q40"
  }, {
    nhtsaId: "1901",
    name: "Q50"
  }, {
    nhtsaId: "1902",
    name: "Q60"
  }, {
    nhtsaId: "1903",
    name: "Q70"
  }, {
    nhtsaId: "1908",
    name: "QX70"
  }, {
    nhtsaId: "1909",
    name: "QX80"
  }, {
    nhtsaId: "1910",
    name: "QX60"
  }, {
    nhtsaId: "2038",
    name: "Q70L"
  }, {
    nhtsaId: "2304",
    name: "Q45"
  }, {
    nhtsaId: "2305",
    name: "G35"
  }, {
    nhtsaId: "2306",
    name: "M35"
  }, {
    nhtsaId: "2307",
    name: "M45"
  }, {
    nhtsaId: "2324",
    name: "FX35"
  }, {
    nhtsaId: "2325",
    name: "FX45"
  }, {
    nhtsaId: "2326",
    name: "QX56"
  }, {
    nhtsaId: "2337",
    name: "G37"
  }, {
    nhtsaId: "2338",
    name: "EX35"
  }, {
    nhtsaId: "2343",
    name: "FX50"
  }, {
    nhtsaId: "2356",
    name: "M56"
  }, {
    nhtsaId: "2357",
    name: "M37"
  }, {
    nhtsaId: "2358",
    name: "G25"
  }, {
    nhtsaId: "2368",
    name: "M35h"
  }, {
    nhtsaId: "2373",
    name: "FX37"
  }, {
    nhtsaId: "2374",
    name: "JX35"
  }, {
    nhtsaId: "5572",
    name: "J30"
  }, {
    nhtsaId: "5573",
    name: "G20"
  }, {
    nhtsaId: "5813",
    name: "I35"
  }, {
    nhtsaId: "8702",
    name: "I30"
  }, {
    nhtsaId: "8717",
    name: "QX4"
  }, {
    nhtsaId: "11510",
    name: "M30"
  }, {
    nhtsaId: "13820",
    name: "QX30"
  }]
}, {
  nhtsaId: 542,
  makeId: "ISU",
  name: "Isuzu",
  models: [{
    nhtsaId: "2817",
    name: "Trooper"
  }, {
    nhtsaId: "2818",
    name: "Rodeo"
  }, {
    nhtsaId: "2819",
    name: "VehiCross"
  }, {
    nhtsaId: "3641",
    name: "NPR/NPR-HD"
  }, {
    nhtsaId: "3642",
    name: "NQR/NRR"
  }, {
    nhtsaId: "4601",
    name: "Ascender"
  }, {
    nhtsaId: "5351",
    name: "Oasis"
  }, {
    nhtsaId: "5950",
    name: "Pickup"
  }, {
    nhtsaId: "6009",
    name: "Axiom"
  }, {
    nhtsaId: "9429",
    name: "Rodeo/Amigo"
  }, {
    nhtsaId: "11474",
    name: "i-280"
  }, {
    nhtsaId: "11484",
    name: "Hombre"
  }, {
    nhtsaId: "14041",
    name: "T6F"
  }, {
    nhtsaId: "14042",
    name: "T7F"
  }, {
    nhtsaId: "14043",
    name: "T8F"
  }, {
    nhtsaId: "14132",
    name: "FRR"
  }, {
    nhtsaId: "14133",
    name: "NQR"
  }, {
    nhtsaId: "14203",
    name: "NPR"
  }, {
    nhtsaId: "14204",
    name: "H-Series"
  }, {
    nhtsaId: "14291",
    name: "F6"
  }, {
    nhtsaId: "14292",
    name: "F7"
  }, {
    nhtsaId: "14354",
    name: "IMPULSE"
  }, {
    nhtsaId: "14355",
    name: "I-Mark"
  }, {
    nhtsaId: "14437",
    name: "FSR"
  }, {
    nhtsaId: "14438",
    name: "FTR/FVR"
  }, {
    nhtsaId: "14453",
    name: "FTR/FVR/EVR"
  }, {
    nhtsaId: "14459",
    name: "Stylus "
  }, {
    nhtsaId: "14508",
    name: "Trooper II"
  }, {
    nhtsaId: "14576",
    name: "Amigo"
  }, {
    nhtsaId: "14582",
    name: "NRR"
  }, {
    nhtsaId: "25826",
    name: "i-350"
  }, {
    nhtsaId: "25827",
    name: "i-290"
  }, {
    nhtsaId: "25828",
    name: "i-370"
  }]
}, {
  nhtsaId: 442,
  makeId: "JAG",
  name: "Jaguar",
  models: [{
    nhtsaId: "2242",
    name: "XJ"
  }, {
    nhtsaId: "2285",
    name: "XF"
  }, {
    nhtsaId: "2286",
    name: "XK"
  }, {
    nhtsaId: "2313",
    name: "X-Type"
  }, {
    nhtsaId: "2314",
    name: "S-Type"
  }, {
    nhtsaId: "2375",
    name: "F-Type"
  }, {
    nhtsaId: "6437",
    name: "Vanden Plas"
  }, {
    nhtsaId: "9339",
    name: "XK8"
  }, {
    nhtsaId: "9340",
    name: "XJR"
  }, {
    nhtsaId: "11440",
    name: "XE"
  }, {
    nhtsaId: "11441",
    name: "F-Pace"
  }, {
    nhtsaId: "13576",
    name: "XJ SEDAN/SUPER 8"
  }, {
    nhtsaId: "13578",
    name: "XJ8/XJ8L"
  }, {
    nhtsaId: "14145",
    name: "XJ6"
  }, {
    nhtsaId: "14615",
    name: "XJS"
  }, {
    nhtsaId: "22434",
    name: "E-PACE"
  }, {
    nhtsaId: "24904",
    name: "I-PACE"
  }, {
    nhtsaId: "25776",
    name: "XJ12"
  }]
}, {
  nhtsaId: 483,
  makeId: "JEEP",
  name: "Jeep",
  models: [{
    nhtsaId: "1943",
    name: "Wrangler"
  }, {
    nhtsaId: "1944",
    name: "Liberty"
  }, {
    nhtsaId: "1945",
    name: "Cherokee"
  }, {
    nhtsaId: "1946",
    name: "Compass"
  }, {
    nhtsaId: "1947",
    name: "Patriot"
  }, {
    nhtsaId: "1948",
    name: "Commander"
  }, {
    nhtsaId: "1949",
    name: "Grand Cherokee"
  }, {
    nhtsaId: "1957",
    name: "Liberty/Cherokee"
  }, {
    nhtsaId: "6160",
    name: "Renegade"
  }, {
    nhtsaId: "14871",
    name: "Grand Wagoneer"
  }, {
    nhtsaId: "14905",
    name: "Comanche"
  }, {
    nhtsaId: "14927",
    name: "Wagoneer"
  }, {
    nhtsaId: "14978",
    name: "J-10"
  }, {
    nhtsaId: "14979",
    name: "J-20"
  }, {
    nhtsaId: "15073",
    name: "CJ-7"
  }, {
    nhtsaId: "15074",
    name: "CJ-8 Scrambler"
  }, {
    nhtsaId: "15086",
    name: "CJ-5"
  }, {
    nhtsaId: "15090",
    name: "CJ-6"
  }, {
    nhtsaId: "25197",
    name: "Wrangler JK"
  }]
}, {
  nhtsaId: 499,
  makeId: "KIA",
  name: "Kia",
  models: [{
    nhtsaId: "2299",
    name: "Rio"
  }, {
    nhtsaId: "2460",
    name: "Soul"
  }, {
    nhtsaId: "2461",
    name: "Borrego"
  }, {
    nhtsaId: "2462",
    name: "Forte"
  }, {
    nhtsaId: "2738",
    name: "Rondo"
  }, {
    nhtsaId: "2739",
    name: "Optima"
  }, {
    nhtsaId: "2740",
    name: "Sedona"
  }, {
    nhtsaId: "2769",
    name: "Sorento"
  }, {
    nhtsaId: "2770",
    name: "Sportage"
  }, {
    nhtsaId: "3071",
    name: "Cadenza"
  }, {
    nhtsaId: "3184",
    name: "K900"
  }, {
    nhtsaId: "5498",
    name: "Sephia"
  }, {
    nhtsaId: "5499",
    name: "Spectra"
  }, {
    nhtsaId: "5500",
    name: "Amanti"
  }, {
    nhtsaId: "5759",
    name: "Spectra LD"
  }, {
    nhtsaId: "9243",
    name: "Sephia II/Spectra"
  }, {
    nhtsaId: "12815",
    name: "Forte Koup"
  }, {
    nhtsaId: "13630",
    name: "Soul EV"
  }, {
    nhtsaId: "15705",
    name: "Niro"
  }, {
    nhtsaId: "21370",
    name: "Stinger"
  }, {
    nhtsaId: "21371",
    name: "Optima Hybrid/Plug-in Hybrid"
  }, {
    nhtsaId: "25756",
    name: "Telluride"
  }]
}, {
  nhtsaId: 502,
  makeId: "LAM",
  name: "Lamborghini",
  models: [{
    nhtsaId: "2066",
    name: "Murcielago"
  }, {
    nhtsaId: "2067",
    name: "Gallardo"
  }, {
    nhtsaId: "8619",
    name: "Diablo"
  }, {
    nhtsaId: "8621",
    name: "147"
  }, {
    nhtsaId: "9927",
    name: "Aventador"
  }, {
    nhtsaId: "9928",
    name: "Hurracan"
  }, {
    nhtsaId: "25121",
    name: "URUS"
  }]
}, {
  nhtsaId: 497,
  makeId: "LAN",
  name: "Lancia",
  models: [{
    nhtsaId: "2051",
    name: "Thema"
  }, {
    nhtsaId: "2052",
    name: "Flavia"
  }, {
    nhtsaId: "3486",
    name: "RTL53"
  }]
}, {
  nhtsaId: 515,
  makeId: "LEXUS",
  name: "Lexus",
  models: [{
    nhtsaId: "2180",
    name: "GS"
  }, {
    nhtsaId: "2182",
    name: "LS"
  }, {
    nhtsaId: "2183",
    name: "SC"
  }, {
    nhtsaId: "2184",
    name: "IS"
  }, {
    nhtsaId: "2212",
    name: "LX"
  }, {
    nhtsaId: "2214",
    name: "RX"
  }, {
    nhtsaId: "2215",
    name: "GX"
  }, {
    nhtsaId: "2475",
    name: "ES"
  }, {
    nhtsaId: "3154",
    name: "CT"
  }, {
    nhtsaId: "3185",
    name: "HS"
  }, {
    nhtsaId: "3406",
    name: "RC"
  }, {
    nhtsaId: "3652",
    name: "LFA"
  }, {
    nhtsaId: "3653",
    name: "NX"
  }, {
    nhtsaId: "14273",
    name: "LC500 / LC 500h"
  }, {
    nhtsaId: "19306",
    name: "LX 570"
  }, {
    nhtsaId: "21951",
    name: "RC F"
  }, {
    nhtsaId: "24941",
    name: "LC"
  }, {
    nhtsaId: "24984",
    name: "UX"
  }]
}, {
  nhtsaId: 464,
  makeId: "LINC",
  name: "Lincoln",
  models: [{
    nhtsaId: "1790",
    name: "MKZ"
  }, {
    nhtsaId: "1791",
    name: "Town Car"
  }, {
    nhtsaId: "1794",
    name: "MKS"
  }, {
    nhtsaId: "1812",
    name: "MKT"
  }, {
    nhtsaId: "1813",
    name: "MKX"
  }, {
    nhtsaId: "1814",
    name: "Navigator"
  }, {
    nhtsaId: "2367",
    name: "LS"
  }, {
    nhtsaId: "2653",
    name: "Aviator"
  }, {
    nhtsaId: "2776",
    name: "Zephyr"
  }, {
    nhtsaId: "2808",
    name: "Mark LT"
  }, {
    nhtsaId: "3599",
    name: "MKC"
  }, {
    nhtsaId: "5192",
    name: "Continental"
  }, {
    nhtsaId: "5273",
    name: "Blackwood"
  }, {
    nhtsaId: "6794",
    name: "Mark"
  }, {
    nhtsaId: "24892",
    name: "Nautilus"
  }, {
    nhtsaId: "25596",
    name: "Corsair"
  }, {
    nhtsaId: "25741",
    name: "Navigator L"
  }]
}, {
  nhtsaId: 466,
  makeId: "LOTUS",
  name: "Lotus",
  models: [{
    nhtsaId: "1795",
    name: "Evora"
  }, {
    nhtsaId: "3106",
    name: "Elise"
  }, {
    nhtsaId: "3107",
    name: "Eleven"
  }, {
    nhtsaId: "3112",
    name: "Esprit"
  }, {
    nhtsaId: "3113",
    name: "Eagle"
  }, {
    nhtsaId: "3114",
    name: "Europa"
  }, {
    nhtsaId: "3115",
    name: "Monaco"
  }, {
    nhtsaId: "3116",
    name: "MEL"
  }, {
    nhtsaId: "3117",
    name: "Elite"
  }, {
    nhtsaId: "3118",
    name: "Eclat"
  }, {
    nhtsaId: "3119",
    name: "Elan"
  }, {
    nhtsaId: "3122",
    name: "Exige"
  }, {
    nhtsaId: "3123",
    name: "Spa"
  }, {
    nhtsaId: "3124",
    name: "340R"
  }, {
    nhtsaId: "3125",
    name: "Monza"
  }, {
    nhtsaId: "3421",
    name: "2-Eleven"
  }, {
    nhtsaId: "12434",
    name: "Turbo Esprit"
  }]
}, {
  nhtsaId: 443,
  makeId: "MAS",
  name: "Maserati",
  models: [{
    nhtsaId: "1699",
    name: "Quattroporte"
  }, {
    nhtsaId: "1700",
    name: "Granturismo"
  }, {
    nhtsaId: "9746",
    name: "Coupe"
  }, {
    nhtsaId: "9747",
    name: "Spyder"
  }, {
    nhtsaId: "11445",
    name: "Ghibli"
  }, {
    nhtsaId: "11446",
    name: "Levante"
  }, {
    nhtsaId: "14622",
    name: "Merak"
  }, {
    nhtsaId: "14623",
    name: "Biturbo"
  }, {
    nhtsaId: "23167",
    name: "TC"
  }, {
    nhtsaId: "23168",
    name: "430"
  }, {
    nhtsaId: "23169",
    name: "228"
  }]
}, {
  nhtsaId: 533,
  makeId: "MAYBACH",
  name: "Maybach",
  models: [{
    nhtsaId: "2775",
    name: "Maybach"
  }]
}, {
  nhtsaId: 473,
  makeId: "MAZDA",
  name: "Mazda",
  models: [{
    nhtsaId: "1860",
    name: "Tribute"
  }, {
    nhtsaId: "2072",
    name: "MX-5"
  }, {
    nhtsaId: "2073",
    name: "RX-8"
  }, {
    nhtsaId: "2074",
    name: "Mazda3"
  }, {
    nhtsaId: "2075",
    name: "Mazda5"
  }, {
    nhtsaId: "2076",
    name: "CX-7"
  }, {
    nhtsaId: "2077",
    name: "CX-9"
  }, {
    nhtsaId: "2078",
    name: "Mazda6"
  }, {
    nhtsaId: "2153",
    name: "Mazda2"
  }, {
    nhtsaId: "2322",
    name: "MPV"
  }, {
    nhtsaId: "2369",
    name: "CX-5"
  }, {
    nhtsaId: "2741",
    name: "B-Series"
  }, {
    nhtsaId: "5410",
    name: "Protege"
  }, {
    nhtsaId: "5470",
    name: "Millenia"
  }, {
    nhtsaId: "5471",
    name: "626"
  }, {
    nhtsaId: "5494",
    name: "323"
  }, {
    nhtsaId: "5495",
    name: "MX-3"
  }, {
    nhtsaId: "5496",
    name: "929"
  }, {
    nhtsaId: "5497",
    name: "RX-7"
  }, {
    nhtsaId: "7791",
    name: "MX-6"
  }, {
    nhtsaId: "10202",
    name: "CX-3"
  }, {
    nhtsaId: "13839",
    name: "GLC"
  }, {
    nhtsaId: "13901",
    name: "Navajo"
  }]
}, {
  nhtsaId: 449,
  makeId: "MB",
  name: "Mercedes-Benz",
  models: [{
    nhtsaId: "1703",
    name: "Sprinter"
  }, {
    nhtsaId: "2079",
    name: "SL-Class"
  }, {
    nhtsaId: "2080",
    name: "SLK-Class"
  }, {
    nhtsaId: "2081",
    name: "E-Class"
  }, {
    nhtsaId: "2082",
    name: "CLS-Class"
  }, {
    nhtsaId: "2083",
    name: "CLA-Class"
  }, {
    nhtsaId: "2084",
    name: "GLA-Class"
  }, {
    nhtsaId: "2085",
    name: "C-Class"
  }, {
    nhtsaId: "2086",
    name: "S-Class"
  }, {
    nhtsaId: "2087",
    name: "SLS-Class"
  }, {
    nhtsaId: "2113",
    name: "B-Class"
  }, {
    nhtsaId: "2129",
    name: "M-Class"
  }, {
    nhtsaId: "2130",
    name: "GL-Class"
  }, {
    nhtsaId: "2131",
    name: "G-Class"
  }, {
    nhtsaId: "2132",
    name: "GLK-Class"
  }, {
    nhtsaId: "2678",
    name: "CL-Class"
  }, {
    nhtsaId: "2822",
    name: "CLK-Class"
  }, {
    nhtsaId: "2936",
    name: "SLR McLaren"
  }, {
    nhtsaId: "2939",
    name: "R-Class"
  }, {
    nhtsaId: "5881",
    name: "AMG GT"
  }, {
    nhtsaId: "5885",
    name: "GLC"
  }, {
    nhtsaId: "5886",
    name: "GLE"
  }, {
    nhtsaId: "11451",
    name: "METRIS"
  }, {
    nhtsaId: "11452",
    name: "SLC - Class"
  }, {
    nhtsaId: "13819",
    name: "ML-Class"
  }, {
    nhtsaId: "14005",
    name: "GLS-Class"
  }, {
    nhtsaId: "14013",
    name: "190"
  }, {
    nhtsaId: "14014",
    name: "300"
  }, {
    nhtsaId: "14015",
    name: "500"
  }, {
    nhtsaId: "14081",
    name: "L1013"
  }, {
    nhtsaId: "14082",
    name: "L1113"
  }, {
    nhtsaId: "14083",
    name: "L1116"
  }, {
    nhtsaId: "14084",
    name: "L1316"
  }, {
    nhtsaId: "14085",
    name: "L1418"
  }, {
    nhtsaId: "14087",
    name: "L1117"
  }, {
    nhtsaId: "14088",
    name: "L1317"
  }, {
    nhtsaId: "14089",
    name: "L1419"
  }, {
    nhtsaId: "14090",
    name: "LP1419"
  }, {
    nhtsaId: "14091",
    name: "LPS1525"
  }, {
    nhtsaId: "14092",
    name: "LP1219"
  }, {
    nhtsaId: "14093",
    name: "L1319"
  }, {
    nhtsaId: "14773",
    name: "280"
  }, {
    nhtsaId: "14774",
    name: "240"
  }, {
    nhtsaId: "14775",
    name: "380"
  }, {
    nhtsaId: "17597",
    name: "400"
  }, {
    nhtsaId: "17598",
    name: "600"
  }, {
    nhtsaId: "17599",
    name: "350"
  }, {
    nhtsaId: "17600",
    name: "420"
  }, {
    nhtsaId: "17601",
    name: "560"
  }, {
    nhtsaId: "17602",
    name: "260"
  }, {
    nhtsaId: "24879",
    name: "A-Class"
  }]
}, {
  nhtsaId: 2236,
  makeId: "MCLAREN",
  name: "Mclaren",
  models: [{
    nhtsaId: "6029",
    name: "P11"
  }, {
    nhtsaId: "10239",
    name: "P12"
  }]
}, {
  nhtsaId: 465,
  makeId: "MERC",
  name: "Mercury",
  models: [{
    nhtsaId: "1792",
    name: "Grand Marquis"
  }, {
    nhtsaId: "1793",
    name: "Milan"
  }, {
    nhtsaId: "1815",
    name: "Mariner"
  }, {
    nhtsaId: "1816",
    name: "Mountaineer"
  }, {
    nhtsaId: "2365",
    name: "Sable"
  }, {
    nhtsaId: "2366",
    name: "Montego"
  }, {
    nhtsaId: "2555",
    name: "Monterey"
  }, {
    nhtsaId: "5191",
    name: "Cougar"
  }, {
    nhtsaId: "5258",
    name: "Villager"
  }, {
    nhtsaId: "6732",
    name: "Tracer"
  }, {
    nhtsaId: "6733",
    name: "Mystique"
  }, {
    nhtsaId: "13962",
    name: "Capri"
  }, {
    nhtsaId: "13963",
    name: "Topaz"
  }, {
    nhtsaId: "14195",
    name: "Lynx"
  }, {
    nhtsaId: "14201",
    name: "MARQUIS"
  }, {
    nhtsaId: "14620",
    name: "Zephyr"
  }, {
    nhtsaId: "25134",
    name: "Marauder"
  }]
}, {
  nhtsaId: 5468,
  makeId: "MERKUR",
  name: "MERKUR",
  models: [{
    nhtsaId: "14202",
    name: "XR4Ti"
  }, {
    nhtsaId: "14347",
    name: "Scorpio"
  }]
}, {
  nhtsaId: 456,
  makeId: "MINI",
  name: "MINI",
  models: [{
    nhtsaId: "1761",
    name: "Cooper"
  }, {
    nhtsaId: "1762",
    name: "Cooper S"
  }, {
    nhtsaId: "1763",
    name: "JCW Hardtop"
  }, {
    nhtsaId: "1764",
    name: "Cooper Clubman"
  }, {
    nhtsaId: "1765",
    name: "Cooper S Clubman"
  }, {
    nhtsaId: "1766",
    name: "JCW Clubman"
  }, {
    nhtsaId: "1767",
    name: "Cooper Convertible"
  }, {
    nhtsaId: "1768",
    name: "Cooper S Convertible"
  }, {
    nhtsaId: "1769",
    name: "JCW Convertible"
  }, {
    nhtsaId: "1862",
    name: "Cooper Hardtop"
  }, {
    nhtsaId: "1880",
    name: "Cooper Countryman"
  }, {
    nhtsaId: "1881",
    name: "Cooper S Countryman"
  }, {
    nhtsaId: "1882",
    name: "Cooper S Countryman All4"
  }, {
    nhtsaId: "1883",
    name: "Cooper S Hardtop"
  }, {
    nhtsaId: "1886",
    name: "Cooper Coupe"
  }, {
    nhtsaId: "1887",
    name: "Cooper Coupe"
  }, {
    nhtsaId: "1888",
    name: "Cooper S Coupe"
  }, {
    nhtsaId: "1889",
    name: "JCW Coupe"
  }, {
    nhtsaId: "1925",
    name: "Cooper Roadster"
  }, {
    nhtsaId: "1926",
    name: "Cooper S Roadster"
  }, {
    nhtsaId: "1928",
    name: "Cooper S Paceman"
  }, {
    nhtsaId: "1929",
    name: "Cooper Paceman"
  }, {
    nhtsaId: "1931",
    name: "Cooper S Paceman ALL4"
  }, {
    nhtsaId: "1932",
    name: "JCW Roadster"
  }, {
    nhtsaId: "1933",
    name: "JCW Countryman"
  }, {
    nhtsaId: "1964",
    name: "JCW Paceman"
  }, {
    nhtsaId: "2327",
    name: "Cooper S JCW GP"
  }]
}, {
  nhtsaId: 481,
  makeId: "MIT",
  name: "Mitsubishi",
  models: [{
    nhtsaId: "1950",
    name: "Raider"
  }, {
    nhtsaId: "2163",
    name: "Outlander"
  }, {
    nhtsaId: "2164",
    name: "Lancer"
  }, {
    nhtsaId: "2165",
    name: "Galant"
  }, {
    nhtsaId: "2166",
    name: "Eclipse"
  }, {
    nhtsaId: "2167",
    name: "Endeavor"
  }, {
    nhtsaId: "2318",
    name: "Montero"
  }, {
    nhtsaId: "2321",
    name: "Eclipse Spyder"
  }, {
    nhtsaId: "2336",
    name: "RVR"
  }, {
    nhtsaId: "2339",
    name: "i-MiEV"
  }, {
    nhtsaId: "2340",
    name: "Outlander - PHEV"
  }, {
    nhtsaId: "2342",
    name: "Mirage"
  }, {
    nhtsaId: "5422",
    name: "Expo"
  }, {
    nhtsaId: "5423",
    name: "3000 GT"
  }, {
    nhtsaId: "5424",
    name: "3000 GT Spyder"
  }, {
    nhtsaId: "5425",
    name: "Diamante"
  }, {
    nhtsaId: "5426",
    name: "Truck"
  }, {
    nhtsaId: "5755",
    name: "Montero Sport"
  }, {
    nhtsaId: "5808",
    name: "Lancer SportBack"
  }, {
    nhtsaId: "5809",
    name: "Lancer Evolution"
  }, {
    nhtsaId: "13842",
    name: "Mirage G4"
  }, {
    nhtsaId: "13867",
    name: "Outlander Sport"
  }, {
    nhtsaId: "14367",
    name: "Expo LRV"
  }, {
    nhtsaId: "14423",
    name: "Precis "
  }, {
    nhtsaId: "14441",
    name: "Mirage Station Wagon"
  }, {
    nhtsaId: "14442",
    name: "Space Wagon"
  }, {
    nhtsaId: "14443",
    name: "Wagon"
  }, {
    nhtsaId: "14445",
    name: "Sigma "
  }, {
    nhtsaId: "14446",
    name: "Starion "
  }, {
    nhtsaId: "14449",
    name: "Van "
  }, {
    nhtsaId: "14454",
    name: "Tredia"
  }, {
    nhtsaId: "14455",
    name: "Cordia"
  }, {
    nhtsaId: "14572",
    name: "Mighty Max"
  }, {
    nhtsaId: "14573",
    name: "SPX"
  }, {
    nhtsaId: "14577",
    name: "SP"
  }, {
    nhtsaId: "17617",
    name: "ECLIPSE CROSS"
  }]
}, {
  nhtsaId: 478,
  makeId: "NISSAN",
  name: "Nissan",
  models: [{
    nhtsaId: "1890",
    name: "GT-R"
  }, {
    nhtsaId: "1891",
    name: "VERSA"
  }, {
    nhtsaId: "1894",
    name: "Versa"
  }, {
    nhtsaId: "1898",
    name: "Versa Note"
  }, {
    nhtsaId: "1904",
    name: "Altima"
  }, {
    nhtsaId: "1905",
    name: "Leaf"
  }, {
    nhtsaId: "1906",
    name: "370Z"
  }, {
    nhtsaId: "1907",
    name: "Sentra"
  }, {
    nhtsaId: "1911",
    name: "Pathfinder"
  }, {
    nhtsaId: "1912",
    name: "Juke"
  }, {
    nhtsaId: "1913",
    name: "Rogue"
  }, {
    nhtsaId: "1914",
    name: "Murano"
  }, {
    nhtsaId: "1915",
    name: "Armada"
  }, {
    nhtsaId: "1916",
    name: "Xterra"
  }, {
    nhtsaId: "1917",
    name: "Quest"
  }, {
    nhtsaId: "1918",
    name: "NV200"
  }, {
    nhtsaId: "1919",
    name: "Frontier"
  }, {
    nhtsaId: "1920",
    name: "Titan"
  }, {
    nhtsaId: "1922",
    name: "NV"
  }, {
    nhtsaId: "2302",
    name: "Maxima"
  }, {
    nhtsaId: "2303",
    name: "350Z"
  }, {
    nhtsaId: "2323",
    name: "X-Trail"
  }, {
    nhtsaId: "2341",
    name: "Cube"
  }, {
    nhtsaId: "5565",
    name: "240SX"
  }, {
    nhtsaId: "5566",
    name: "300ZX"
  }, {
    nhtsaId: "5748",
    name: "Pickup"
  }, {
    nhtsaId: "5756",
    name: "Altra-EV"
  }, {
    nhtsaId: "11506",
    name: "NX"
  }, {
    nhtsaId: "11507",
    name: "NX/Sentra"
  }, {
    nhtsaId: "11508",
    name: "Stanza"
  }, {
    nhtsaId: "11509",
    name: "Axxess"
  }, {
    nhtsaId: "13524",
    name: "PULSAR"
  }, {
    nhtsaId: "14272",
    name: "Van"
  }, {
    nhtsaId: "14329",
    name: "Stanza Wagon"
  }, {
    nhtsaId: "14385",
    name: "200SX"
  }, {
    nhtsaId: "17214",
    name: "Rogue Sports"
  }, {
    nhtsaId: "17615",
    name: "Sentra Classic"
  }, {
    nhtsaId: "17616",
    name: "Altra"
  }, {
    nhtsaId: "17817",
    name: "Micra"
  }, {
    nhtsaId: "18137",
    name: "Rogue Select"
  }, {
    nhtsaId: "22791",
    name: "Kicks"
  }]
}, {
  nhtsaId: 4162,
  makeId: "OLDS",
  name: "Oldsmobile",
  models: [{
    nhtsaId: "8920",
    name: "Bravada"
  }, {
    nhtsaId: "8921",
    name: "Silhouette"
  }, {
    nhtsaId: "8955",
    name: "Alero"
  }, {
    nhtsaId: "8957",
    name: "Aurora"
  }, {
    nhtsaId: "8988",
    name: "Intrigue"
  }, {
    nhtsaId: "9065",
    name: "Regency"
  }, {
    nhtsaId: "9066",
    name: "Eighty Eight (88)"
  }, {
    nhtsaId: "9067",
    name: "LSS"
  }, {
    nhtsaId: "9068",
    name: "Cutlass"
  }, {
    nhtsaId: "9089",
    name: "Achieva"
  }, {
    nhtsaId: "9096",
    name: "Cutlass Supreme"
  }, {
    nhtsaId: "9118",
    name: "Ciera"
  }, {
    nhtsaId: "14175",
    name: "Ninety Eight (98)"
  }, {
    nhtsaId: "14176",
    name: "Custom Cruiser"
  }, {
    nhtsaId: "14181",
    name: "Toronado"
  }, {
    nhtsaId: "14341",
    name: "Cutlass Calais"
  }, {
    nhtsaId: "14473",
    name: "Firenza"
  }, {
    nhtsaId: "14550",
    name: "Omega"
  }, {
    nhtsaId: "14552",
    name: "Cutlass Ciera"
  }, {
    nhtsaId: "14553",
    name: "Delta 88"
  }, {
    nhtsaId: "14561",
    name: "Cutlass Cruiser"
  }, {
    nhtsaId: "22444",
    name: "Cutlass Salon"
  }]
}, {
  nhtsaId: 5554,
  makeId: "PEUG",
  name: "Peugeot",
  models: [{
    nhtsaId: "14339",
    name: "505"
  }, {
    nhtsaId: "14340",
    name: "405"
  }, {
    nhtsaId: "14624",
    name: "604"
  }, {
    nhtsaId: "14625",
    name: "504"
  }]
}, {
  nhtsaId: 2409,
  makeId: "PLYM",
  name: "Plymouth",
  models: [{
    nhtsaId: "6495",
    name: "Neon"
  }, {
    nhtsaId: "6496",
    name: "Breeze"
  }, {
    nhtsaId: "6673",
    name: "Prowler"
  }, {
    nhtsaId: "14352",
    name: "Acclaim"
  }, {
    nhtsaId: "14353",
    name: "Colt"
  }, {
    nhtsaId: "14358",
    name: "Sundance"
  }, {
    nhtsaId: "14359",
    name: "Laser"
  }, {
    nhtsaId: "14398",
    name: "HORIZON"
  }, {
    nhtsaId: "14406",
    name: "TURISMO"
  }, {
    nhtsaId: "14407",
    name: "RELIANT"
  }, {
    nhtsaId: "14408",
    name: "CARAVELLE"
  }, {
    nhtsaId: "14409",
    name: "GRAN FURY"
  }, {
    nhtsaId: "14410",
    name: "CONQUEST"
  }, {
    nhtsaId: "14716",
    name: "SAPPORO"
  }, {
    nhtsaId: "14761",
    name: "Champ"
  }, {
    nhtsaId: "14861",
    name: "Voyager"
  }, {
    nhtsaId: "14862",
    name: "Grand Voyager"
  }, {
    nhtsaId: "15088",
    name: "Scamp"
  }, {
    nhtsaId: "15089",
    name: "Arrow"
  }, {
    nhtsaId: "15123",
    name: "Trailduster"
  }]
}, {
  nhtsaId: 536,
  makeId: "PONT",
  name: "Pontiac",
  models: [{
    nhtsaId: "2807",
    name: "Vibe"
  }, {
    nhtsaId: "4259",
    name: "G5"
  }, {
    nhtsaId: "4260",
    name: "Solstice"
  }, {
    nhtsaId: "4261",
    name: "Wave"
  }, {
    nhtsaId: "4262",
    name: "Grand Prix"
  }, {
    nhtsaId: "4263",
    name: "G6"
  }, {
    nhtsaId: "4264",
    name: "G8"
  }, {
    nhtsaId: "4265",
    name: "G3"
  }, {
    nhtsaId: "4589",
    name: "Montana/ SV6"
  }, {
    nhtsaId: "4591",
    name: "Torrent"
  }, {
    nhtsaId: "4777",
    name: "Pursuit"
  }, {
    nhtsaId: "4993",
    name: "GTO"
  }, {
    nhtsaId: "6109",
    name: "Matiz"
  }, {
    nhtsaId: "8838",
    name: "Bonneville"
  }, {
    nhtsaId: "8839",
    name: "Sunfire"
  }, {
    nhtsaId: "8840",
    name: "Grand AM"
  }, {
    nhtsaId: "8884",
    name: "Aztek"
  }, {
    nhtsaId: "8986",
    name: "Firebird"
  }, {
    nhtsaId: "9140",
    name: "Sunbird"
  }, {
    nhtsaId: "11498",
    name: "Trans Sport"
  }, {
    nhtsaId: "14169",
    name: "Firefly"
  }, {
    nhtsaId: "14170",
    name: "Lemans"
  }, {
    nhtsaId: "14335",
    name: "6000"
  }, {
    nhtsaId: "14467",
    name: "Parisienne"
  }, {
    nhtsaId: "14471",
    name: "Fiero"
  }, {
    nhtsaId: "14482",
    name: "T1000"
  }, {
    nhtsaId: "14548",
    name: "Sunbird 2000"
  }, {
    nhtsaId: "14549",
    name: "Phoenix"
  }, {
    nhtsaId: "22059",
    name: "Grand Lemans"
  }, {
    nhtsaId: "22061",
    name: "Catalina"
  }, {
    nhtsaId: "22075",
    name: "J2000"
  }, {
    nhtsaId: "22106",
    name: "Safari"
  }, {
    nhtsaId: "22107",
    name: "Tempest"
  }, {
    nhtsaId: "22114",
    name: "Acadian"
  }, {
    nhtsaId: "22116",
    name: "Sunburst"
  }, {
    nhtsaId: "22168",
    name: "Laurentian"
  }]
}, {
  nhtsaId: 584,
  makeId: "POR",
  name: "Porsche",
  models: [{
    nhtsaId: "7832",
    name: "911"
  }, {
    nhtsaId: "7847",
    name: "Boxster"
  }, {
    nhtsaId: "7895",
    name: "Cayenne"
  }, {
    nhtsaId: "7897",
    name: "Carrera"
  }, {
    nhtsaId: "7900",
    name: "Cayman"
  }, {
    nhtsaId: "7994",
    name: "Panamera"
  }, {
    nhtsaId: "8022",
    name: "918"
  }, {
    nhtsaId: "8031",
    name: "Macan"
  }, {
    nhtsaId: "13846",
    name: "944"
  }, {
    nhtsaId: "13847",
    name: "928"
  }, {
    nhtsaId: "13848",
    name: "924"
  }, {
    nhtsaId: "13871",
    name: "Boxster S"
  }, {
    nhtsaId: "14080",
    name: "968"
  }, {
    nhtsaId: "18282",
    name: "718"
  }]
}, {
  nhtsaId: 496,
  makeId: "RAM",
  name: "Ram",
  models: [{
    nhtsaId: "2050",
    name: "Promaster City"
  }, {
    nhtsaId: "13620",
    name: "1500"
  }, {
    nhtsaId: "13621",
    name: "2500"
  }, {
    nhtsaId: "13622",
    name: "3500"
  }, {
    nhtsaId: "13623",
    name: "4000"
  }, {
    nhtsaId: "13624",
    name: "4500"
  }, {
    nhtsaId: "13625",
    name: "5500"
  }, {
    nhtsaId: "13627",
    name: "Promaster 1500"
  }, {
    nhtsaId: "13628",
    name: "Promaster 2500"
  }, {
    nhtsaId: "13629",
    name: "Promaster 3500"
  }, {
    nhtsaId: "13907",
    name: "Cargo Van"
  }]
}, {
  nhtsaId: 444,
  makeId: "ROV",
  name: "Land Rover",
  models: [{
    nhtsaId: "2241",
    name: "Discovery Sport"
  }, {
    nhtsaId: "2243",
    name: "LR2"
  }, {
    nhtsaId: "2244",
    name: "Range Rover Evoque"
  }, {
    nhtsaId: "2245",
    name: "LR4"
  }, {
    nhtsaId: "2246",
    name: "Range Rover Sport"
  }, {
    nhtsaId: "2247",
    name: "Range Rover"
  }, {
    nhtsaId: "2301",
    name: "LR3"
  }, {
    nhtsaId: "9337",
    name: "Discovery"
  }, {
    nhtsaId: "9338",
    name: "Freelander"
  }, {
    nhtsaId: "9345",
    name: "Defender"
  }, {
    nhtsaId: "19055",
    name: "Range Rover Velar"
  }]
}, {
  nhtsaId: 445,
  makeId: "RR",
  name: "Rolls Royce",
  models: [{
    nhtsaId: "1689",
    name: "Phantom"
  }, {
    nhtsaId: "1690",
    name: "Ghost"
  }, {
    nhtsaId: "1691",
    name: "Wraith"
  }, {
    nhtsaId: "9786",
    name: "Silver Dawn"
  }, {
    nhtsaId: "9790",
    name: "Silver Spur"
  }, {
    nhtsaId: "9792",
    name: "Silver Spirit"
  }, {
    nhtsaId: "9794",
    name: "Project P80"
  }, {
    nhtsaId: "9795",
    name: "Touring Limousine"
  }, {
    nhtsaId: "9796",
    name: "Project P70"
  }, {
    nhtsaId: "9825",
    name: "Corniche"
  }, {
    nhtsaId: "9826",
    name: "Park Ward"
  }, {
    nhtsaId: "9827",
    name: "Extended Wheelbase"
  }, {
    nhtsaId: "9830",
    name: "Silver Seraph"
  }, {
    nhtsaId: "10289",
    name: "Dawn"
  }, {
    nhtsaId: "14259",
    name: "Convertible "
  }, {
    nhtsaId: "14260",
    name: "Camargue"
  }]
}, {
  nhtsaId: 572,
  makeId: "SAAB",
  name: "SAAB",
  models: [{
    nhtsaId: "2992",
    name: "9-3"
  }, {
    nhtsaId: "2993",
    name: "9-5"
  }, {
    nhtsaId: "4094",
    name: "9-4x"
  }, {
    nhtsaId: "4603",
    name: "9-7X"
  }, {
    nhtsaId: "10049",
    name: "900"
  }, {
    nhtsaId: "10050",
    name: "9000"
  }, {
    nhtsaId: "11604",
    name: "9-2X"
  }]
}, {
  nhtsaId: 1056,
  makeId: "SATURN",
  name: "Saturn",
  models: [{
    nhtsaId: "4323",
    name: "Astra"
  }, {
    nhtsaId: "4335",
    name: "Sky"
  }, {
    nhtsaId: "4336",
    name: "Aura"
  }, {
    nhtsaId: "4595",
    name: "Vue"
  }, {
    nhtsaId: "4596",
    name: "Outlook"
  }, {
    nhtsaId: "4781",
    name: "Ion"
  }, {
    nhtsaId: "4964",
    name: "Relay"
  }, {
    nhtsaId: "8852",
    name: "L300"
  }, {
    nhtsaId: "8958",
    name: "L200"
  }, {
    nhtsaId: "8990",
    name: "SL"
  }, {
    nhtsaId: "8991",
    name: "SL1"
  }, {
    nhtsaId: "8992",
    name: "SL2"
  }, {
    nhtsaId: "8993",
    name: "SC1"
  }, {
    nhtsaId: "8994",
    name: "SC2"
  }, {
    nhtsaId: "8995",
    name: "LS"
  }, {
    nhtsaId: "9024",
    name: "SW1"
  }, {
    nhtsaId: "9070",
    name: "SW2"
  }, {
    nhtsaId: "10997",
    name: "LS1"
  }, {
    nhtsaId: "10998",
    name: "LS2"
  }, {
    nhtsaId: "10999",
    name: "LW2"
  }, {
    nhtsaId: "11000",
    name: "LW1"
  }, {
    nhtsaId: "13757",
    name: "LW200"
  }, {
    nhtsaId: "13758",
    name: "LW300"
  }, {
    nhtsaId: "14186",
    name: "SL3"
  }]
}, {
  nhtsaId: 504,
  makeId: "SMART",
  name: "smart",
  models: [{
    nhtsaId: "2114",
    name: "smart"
  }, {
    nhtsaId: "10424",
    name: "Fortwo"
  }, {
    nhtsaId: "24758",
    name: "EQ Fortwo"
  }, {
    nhtsaId: "25775",
    name: "Fortwo Electric Drive"
  }]
}, {
  nhtsaId: 523,
  makeId: "SUB",
  name: "Subaru",
  models: [{
    nhtsaId: "2232",
    name: "Legacy"
  }, {
    nhtsaId: "2233",
    name: "Outback"
  }, {
    nhtsaId: "2234",
    name: "Forester"
  }, {
    nhtsaId: "2235",
    name: "Impreza"
  }, {
    nhtsaId: "2236",
    name: "XV CrossTrek"
  }, {
    nhtsaId: "2237",
    name: "WRX"
  }, {
    nhtsaId: "2238",
    name: "BRZ"
  }, {
    nhtsaId: "2319",
    name: "Baja"
  }, {
    nhtsaId: "2320",
    name: "B9 Tribeca"
  }, {
    nhtsaId: "6093",
    name: "SVX"
  }, {
    nhtsaId: "13580",
    name: "Crosstrek"
  }, {
    nhtsaId: "14213",
    name: "Justy"
  }, {
    nhtsaId: "14226",
    name: "Loyale"
  }, {
    nhtsaId: "14245",
    name: "Brat"
  }, {
    nhtsaId: "17873",
    name: "XT"
  }, {
    nhtsaId: "17874",
    name: "XT6"
  }, {
    nhtsaId: "18054",
    name: "DL"
  }, {
    nhtsaId: "18055",
    name: "GL"
  }, {
    nhtsaId: "18056",
    name: "GL-10"
  }, {
    nhtsaId: "18059",
    name: "RX"
  }, {
    nhtsaId: "18081",
    name: "Standard"
  }, {
    nhtsaId: "18099",
    name: "GLF"
  }, {
    nhtsaId: "24836",
    name: "Ascent"
  }]
}, {
  nhtsaId: 509,
  makeId: "SUZUKI",
  name: "Suzuki",
  models: [{
    nhtsaId: "3138",
    name: "Grand Vitara/Grand Vitara XL-7"
  }, {
    nhtsaId: "3139",
    name: "Aerio"
  }, {
    nhtsaId: "3143",
    name: "XL7"
  }, {
    nhtsaId: "3152",
    name: "SX4"
  }, {
    nhtsaId: "3156",
    name: "Equator"
  }, {
    nhtsaId: "3157",
    name: "Kizashi"
  }, {
    nhtsaId: "6105",
    name: "Swift"
  }, {
    nhtsaId: "6106",
    name: "Forenza "
  }, {
    nhtsaId: "6107",
    name: "Reno"
  }, {
    nhtsaId: "8564",
    name: "Esteem"
  }, {
    nhtsaId: "8568",
    name: "Vitara"
  }, {
    nhtsaId: "8572",
    name: "Sidekick"
  }, {
    nhtsaId: "8574",
    name: "Sidekick Sport"
  }, {
    nhtsaId: "8575",
    name: "X-90"
  }, {
    nhtsaId: "10291",
    name: "Grand Vitara"
  }, {
    nhtsaId: "10292",
    name: "Grand Vitara XL-7"
  }, {
    nhtsaId: "10987",
    name: "Verona"
  }, {
    nhtsaId: "11605",
    name: "Samurai"
  }, {
    nhtsaId: "14597",
    name: "Forsa"
  }]
}, {
  nhtsaId: 441,
  makeId: "TESLA",
  name: "Tesla",
  models: [{
    nhtsaId: "1685",
    name: "Model S"
  }, {
    nhtsaId: "2071",
    name: "Roadster"
  }, {
    nhtsaId: "10199",
    name: "Model X"
  }, {
    nhtsaId: "17834",
    name: "Model 3"
  }]
}, {
  nhtsaId: 448,
  makeId: "TOYOTA",
  name: "Toyota",
  models: [{
    nhtsaId: "2206",
    name: "SCION xA"
  }, {
    nhtsaId: "2207",
    name: "SCION tC"
  }, {
    nhtsaId: "2208",
    name: "Corolla"
  }, {
    nhtsaId: "2209",
    name: "PRIUS"
  }, {
    nhtsaId: "2210",
    name: "SCION xB"
  }, {
    nhtsaId: "2211",
    name: "LAND CRUISER"
  }, {
    nhtsaId: "2213",
    name: "Highlander"
  }, {
    nhtsaId: "2216",
    name: "4-Runner"
  }, {
    nhtsaId: "2217",
    name: "RAV4"
  }, {
    nhtsaId: "2223",
    name: "Tacoma"
  }, {
    nhtsaId: "2315",
    name: "Scion FR-S"
  }, {
    nhtsaId: "2463",
    name: "FJ Cruiser"
  }, {
    nhtsaId: "2464",
    name: "Yaris"
  }, {
    nhtsaId: "2465",
    name: "Avalon"
  }, {
    nhtsaId: "2466",
    name: "Corolla Matrix"
  }, {
    nhtsaId: "2467",
    name: "Tundra"
  }, {
    nhtsaId: "2468",
    name: "Sienna"
  }, {
    nhtsaId: "2469",
    name: "Camry"
  }, {
    nhtsaId: "2803",
    name: "Solara"
  }, {
    nhtsaId: "2827",
    name: "Sequoia"
  }, {
    nhtsaId: "2933",
    name: "SCION xD"
  }, {
    nhtsaId: "3005",
    name: "Venza"
  }, {
    nhtsaId: "3155",
    name: "FCHV-adv"
  }, {
    nhtsaId: "3644",
    name: "Tercel"
  }, {
    nhtsaId: "3645",
    name: "Celica"
  }, {
    nhtsaId: "3647",
    name: "Supra"
  }, {
    nhtsaId: "3648",
    name: "MR2"
  }, {
    nhtsaId: "3649",
    name: "Paseo"
  }, {
    nhtsaId: "3650",
    name: "Echo"
  }, {
    nhtsaId: "3655",
    name: "Cressida"
  }, {
    nhtsaId: "3659",
    name: "1-ton"
  }, {
    nhtsaId: "3660",
    name: "Cargo Van"
  }, {
    nhtsaId: "9373",
    name: "Previa"
  }, {
    nhtsaId: "9374",
    name: "T100"
  }, {
    nhtsaId: "10198",
    name: "Mirai"
  }, {
    nhtsaId: "10241",
    name: "Scion iQ"
  }, {
    nhtsaId: "11501",
    name: "Scion iM"
  }, {
    nhtsaId: "13602",
    name: "86"
  }, {
    nhtsaId: "13603",
    name: "Scion iA"
  }, {
    nhtsaId: "13822",
    name: "Prius V"
  }, {
    nhtsaId: "13823",
    name: "Prius C"
  }, {
    nhtsaId: "13824",
    name: "Prius Plug-in"
  }, {
    nhtsaId: "14263",
    name: "Pick-Up"
  }, {
    nhtsaId: "14264",
    name: "Van"
  }, {
    nhtsaId: "14510",
    name: "Starlet"
  }, {
    nhtsaId: "14551",
    name: "Corona"
  }, {
    nhtsaId: "15800",
    name: "COROLLA iM"
  }, {
    nhtsaId: "17213",
    name: "C-HR"
  }, {
    nhtsaId: "17620",
    name: "CAMRY HYBRID"
  }, {
    nhtsaId: "21950",
    name: "Prius Prime"
  }, {
    nhtsaId: "24949",
    name: "Yaris iA"
  }]
}, {
  nhtsaId: 482,
  makeId: "VOLKS",
  name: "Volkswagen",
  models: [{
    nhtsaId: "1951",
    name: "Routan"
  }, {
    nhtsaId: "3133",
    name: "Golf"
  }, {
    nhtsaId: "3134",
    name: "Passat"
  }, {
    nhtsaId: "3135",
    name: "Phaeton"
  }, {
    nhtsaId: "3136",
    name: "Touareg"
  }, {
    nhtsaId: "3137",
    name: "Jetta"
  }, {
    nhtsaId: "3140",
    name: "GTI"
  }, {
    nhtsaId: "3141",
    name: "R32"
  }, {
    nhtsaId: "3142",
    name: "Jetta Wagon"
  }, {
    nhtsaId: "4084",
    name: "Rabbit"
  }, {
    nhtsaId: "4085",
    name: "New GTI"
  }, {
    nhtsaId: "4167",
    name: "Eos"
  }, {
    nhtsaId: "5059",
    name: "Golf SportWagen"
  }, {
    nhtsaId: "8051",
    name: "Golf III"
  }, {
    nhtsaId: "8052",
    name: "Jetta III"
  }, {
    nhtsaId: "8053",
    name: "Corrado"
  }, {
    nhtsaId: "8055",
    name: "Euro Van"
  }, {
    nhtsaId: "8118",
    name: "e-Golf"
  }, {
    nhtsaId: "8119",
    name: "Beetle"
  }, {
    nhtsaId: "8121",
    name: "CC"
  }, {
    nhtsaId: "8151",
    name: "Tiguan"
  }, {
    nhtsaId: "8364",
    name: "Jetta SportWagen"
  }, {
    nhtsaId: "8460",
    name: "Cabrio"
  }, {
    nhtsaId: "8475",
    name: "new Passat"
  }, {
    nhtsaId: "8486",
    name: "New Cabrio"
  }, {
    nhtsaId: "8487",
    name: "New Golf"
  }, {
    nhtsaId: "8488",
    name: "New Jetta"
  }, {
    nhtsaId: "13670",
    name: "Golf GTI"
  }, {
    nhtsaId: "13844",
    name: "Golf R"
  }, {
    nhtsaId: "14216",
    name: "CABRIOLET"
  }, {
    nhtsaId: "14217",
    name: "FOX"
  }, {
    nhtsaId: "14261",
    name: "Quantum"
  }, {
    nhtsaId: "14262",
    name: "scirocco"
  }, {
    nhtsaId: "14266",
    name: "Vanagon"
  }, {
    nhtsaId: "14270",
    name: "MULTI-VAN"
  }, {
    nhtsaId: "14568",
    name: "Dasher"
  }, {
    nhtsaId: "14569",
    name: "KOMBI"
  }, {
    nhtsaId: "17618",
    name: "Atlas"
  }, {
    nhtsaId: "24230",
    name: "Golf Alltrack"
  }, {
    nhtsaId: "24247",
    name: "Tiguan Limited"
  }]
}, {
  nhtsaId: 485,
  makeId: "VOLVO",
  name: "Volvo",
  models: [{
    nhtsaId: "1959",
    name: "S60"
  }, {
    nhtsaId: "1960",
    name: "S80"
  }, {
    nhtsaId: "1961",
    name: "V60"
  }, {
    nhtsaId: "1962",
    name: "XC60"
  }, {
    nhtsaId: "1963",
    name: "XC70"
  }, {
    nhtsaId: "3127",
    name: "S40"
  }, {
    nhtsaId: "3128",
    name: "V50"
  }, {
    nhtsaId: "3129",
    name: "C70"
  }, {
    nhtsaId: "3130",
    name: "V70"
  }, {
    nhtsaId: "3132",
    name: "XC90"
  }, {
    nhtsaId: "3144",
    name: "C30"
  }, {
    nhtsaId: "9341",
    name: "940 Series"
  }, {
    nhtsaId: "9342",
    name: "960 Series"
  }, {
    nhtsaId: "9343",
    name: "850 Series"
  }, {
    nhtsaId: "10206",
    name: "V60CC"
  }, {
    nhtsaId: "10207",
    name: "S60/S60I"
  }, {
    nhtsaId: "10208",
    name: "S60 Cross Country"
  }, {
    nhtsaId: "13798",
    name: "S90"
  }, {
    nhtsaId: "13799",
    name: "V90"
  }, {
    nhtsaId: "13800",
    name: "V90CC"
  }, {
    nhtsaId: "14118",
    name: "240 Series"
  }, {
    nhtsaId: "14119",
    name: "740 Series"
  }, {
    nhtsaId: "14120",
    name: "780 Series"
  }, {
    nhtsaId: "14121",
    name: "760 Series"
  }, {
    nhtsaId: "14124",
    name: "V40"
  }, {
    nhtsaId: "14125",
    name: "S70"
  }, {
    nhtsaId: "14126",
    name: "Cab Over Engine HT"
  }, {
    nhtsaId: "14127",
    name: "Cab Over Engine LT"
  }, {
    nhtsaId: "14128",
    name: "Cab Over Engine Prod. Class 03"
  }, {
    nhtsaId: "14129",
    name: "Cab Over Engine Prod. Class 07"
  }, {
    nhtsaId: "14130",
    name: "F12 w/F7 Cab"
  }, {
    nhtsaId: "14131",
    name: "F6 w/F7 Cab"
  }, {
    nhtsaId: "14134",
    name: "Cab Over Engine Prod. Class 07 (USA) "
  }, {
    nhtsaId: "14135",
    name: "Cab behind engine"
  }, {
    nhtsaId: "14659",
    name: "260 Series"
  }, {
    nhtsaId: "23714",
    name: "XC40"
  }]
}, {
  nhtsaId: 5553,
  makeId: "YUGO",
  name: "YUGO",
  models: [{
    nhtsaId: "14333",
    name: "Yugo 45"
  }, {
    nhtsaId: "14334",
    name: "Yugo 65"
  }, {
    nhtsaId: "15158",
    name: "Yugo 55"
  }, {
    nhtsaId: "24189",
    name: "102, GV"
  }]
}];
